/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Klairo API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Action,
  AdminAccessRequestsResponse,
  AdminAiFailuresResponse,
  AdminAiUploadApprovalResult,
  AdminAiUploadDetail,
  AdminAiUploadReExtractResult,
  AdminAiUploadRejectionResult,
  AdminAiUploadResult,
  AdminAiUploadUndoResult,
  AdminAiUploadsResponse,
  AdminAlertsResponse,
  AdminBillingInvoicesResponse,
  AdminBillingUsageResponse,
  AdminContactNoteResponse,
  AdminContactNotesResponse,
  AdminLeadOrgLinkEventsResponse,
  AdminOrgLeadLinkEventsResponse,
  AdminReviewScanDetailResponse,
  AdminReviewScansResponse,
  AdminRoleUsersResponse,
  AdminSalesLead,
  AdminSalesLeadsResponse,
  AdminStagingUploadApproval,
  AdminStagingUploadCreated,
  AdminStagingUploadDetail,
  AdminStagingUploadsResponse,
  AdminStripeResponse,
  AdminSubscriptionsResponse,
  AdminTenantDetailResponse,
  AdminTenantsResponse,
  AdminUserResponse,
  AdminUsersResponse,
  AnalyticsCorrelationResponse,
  ApproveAdminAiUploadReviewsBody,
  ApproveAdminStagingUploadBody,
  ArchiveBulkRequest,
  ArchiveBulkResponse,
  ArchiveResponse,
  AssignOrgAdminUser200,
  AssignOrgAdminUserBody,
  AuthTenantResponse,
  BillingInfo,
  BillingInvoicesResponse,
  BulkActionRequest,
  BulkActionResponse,
  CreateAccessRequestBody,
  CreateAdminAiUploadBody,
  CreateAdminContactNoteBody,
  CreateAdminSalesLeadBody,
  CreateAdminStagingUpload409,
  CreateAdminStagingUploadBody,
  CreateAdminTenant200,
  CreateAdminTenantBody,
  CreateAdminUserBody,
  CreateAudienceFromSegmentBody,
  CreateAudienceFromSegmentResponse,
  CreateBillingCheckout503,
  CreateCheckoutBody,
  CreateCheckoutResponse,
  CreateFacebookCampaignBody,
  CreateFacebookCampaignResponse,
  CreateNotebookBody,
  CreateNotebookTaskBody,
  CreateTaskBody,
  CurrentCycle,
  CycleDetail,
  CycleSummary,
  DashboardData,
  DataSource,
  DataSourceRun,
  DeleteDataSourceParams,
  DeleteDataSourceResponse,
  Department,
  DepartmentBriefingResponse,
  DepartmentDashboard,
  ExitOnboardingBody,
  FacebookAdCampaignsResponse,
  FacebookAudiencesResponse,
  FacebookCorrelationResponse,
  FacebookOAuthCallbackParams,
  FacebookOAuthStatus,
  FacebookSyncResult,
  FacebookSyncStatusResponse,
  FinalizeImageUploadRequest,
  FinalizeImageUploadResponse,
  GAOAuthStatus,
  GAPropertiesResponse,
  GASyncResult,
  GenerateDepartmentAiBriefingParams,
  GetActiveOrgPreference200,
  GetAdminSalesLeadsParams,
  GetAnalyticsCorrelationParams,
  GetArchiveParams,
  GetAuthTenantParams,
  GetBranches200,
  GetCurrentAuthUserResponse,
  GetDepartmentKpiTrendAnalysisParams,
  GetDepartmentKpiTrendsParams,
  GetFacebookCampaignCorrelationParams,
  GetKpiTrendAnalysisParams,
  GetKpiTrendsParams,
  GetTopicParams,
  GetTopicTrendAnalysisParams,
  GetTopicTrendParams,
  GoogleBackfillSourceUrlsResponse,
  GoogleLocationsResponse,
  GoogleMissingSourceUrlsCountResponse,
  GoogleOAuthStatusResponse,
  GoogleSelectLocationsBody,
  GoogleSelectLocationsResponse,
  GoogleSyncResult,
  GoogleSyncStatusResponse,
  HealthStatus,
  HistoryDetail,
  HistoryEntry,
  Integration,
  KpiTrendAnalysisResponse,
  KpiTrendsResponse,
  ListAdminAiFailuresParams,
  ListAdminAiUploadsParams,
  ListAdminAlertsParams,
  ListAdminOrgs200,
  ListAdminOrgsParams,
  ListAdminReviewScansParams,
  ListAdminStagingUploadsParams,
  ListAdminTenantsParams,
  ListAdminUsersParams,
  ListCycles200,
  ListHistoryParams,
  ListNotebookTasksResponse,
  ListNotebooksParams,
  ListNotebooksResponse,
  ListReviewsParams,
  ListTasksParams,
  ListTasksResponse,
  ListTopicsParams,
  NotebookDetailResponse,
  NotebookResponse,
  NotebookTaskResponse,
  NotificationsListResponse,
  OnboardingState,
  ReExtractAdminAiUpload409,
  RejectAdminAiUploadReviewsBody,
  RejectAdminStagingUpload200,
  RejectAdminStagingUploadBody,
  RemapDataSourceBody,
  ReviewItem,
  ReviewsListResponse,
  RunOrgAnalysis200,
  SearchAdminRoleUsersParams,
  SelectGAPropertyBody,
  SetActiveOrgPreference200,
  SetActiveOrgPreferenceBody,
  Settings,
  StorageErrorEnvelope,
  SuccessResponse,
  SyncAdminStripe200,
  TaskResponse,
  TopicDetail,
  TopicTrendResponse,
  TopicsListResponse,
  UndoAdminAiUploadReviewsBody,
  UpdateActionStatusBody,
  UpdateAdminContactNoteBody,
  UpdateAdminRole200,
  UpdateAdminRoleBody,
  UpdateAdminSalesLeadBody,
  UpdateAdminStagingUploadReview200,
  UpdateAdminStagingUploadReviewBody,
  UpdateAdminSubscription200,
  UpdateAdminSubscriptionBody,
  UpdateAdminTenant200,
  UpdateAdminTenantBody,
  UpdateAdminUser200,
  UpdateAdminUserBody,
  UpdateCampaignStatusBody,
  UpdateNotebookBody,
  UpdateNotebookTaskBody,
  UpdateOnboardingBody,
  UpdateReportingCadence200,
  UpdateReportingCadenceBody,
  UpdateReviewStatusBody,
  UpdateSettingsBody,
  UpdateTaskBody,
  UpdateZapierConfigBody,
  UpgradePlanBody,
  UploadDataSourceBody,
  UploadUrlRequest,
  UploadUrlResponse,
  VerifyFirebaseTokenBody,
  VerifyFirebaseTokenResponse,
  WipeAdminTenantReviews200,
  WipeAdminTenantReviewsBody,
  ZapierConfigResponse,
  ZapierConfigSaveResponse,
  ZapierInboundBody,
  ZapierInboundResponse,
  ZapierLogsResponse,
  ZapierTestResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List recent unparseable AI responses (super_admin only)
 */
export const getListAdminAiFailuresUrl = (
  params?: ListAdminAiFailuresParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/ai-failures?${stringifiedParams}`
    : `/api/admin/ai-failures`;
};

export const listAdminAiFailures = async (
  params?: ListAdminAiFailuresParams,
  options?: RequestInit,
): Promise<AdminAiFailuresResponse> => {
  return customFetch<AdminAiFailuresResponse>(
    getListAdminAiFailuresUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminAiFailuresQueryKey = (
  params?: ListAdminAiFailuresParams,
) => {
  return [`/api/admin/ai-failures`, ...(params ? [params] : [])] as const;
};

export const getListAdminAiFailuresQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAiFailures>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminAiFailuresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAiFailures>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminAiFailuresQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminAiFailures>>
  > = ({ signal }) =>
    listAdminAiFailures(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminAiFailures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminAiFailuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAiFailures>>
>;
export type ListAdminAiFailuresQueryError = ErrorType<unknown>;

/**
 * @summary List recent unparseable AI responses (super_admin only)
 */

export function useListAdminAiFailures<
  TData = Awaited<ReturnType<typeof listAdminAiFailures>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminAiFailuresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAiFailures>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminAiFailuresQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List recent review scan jobs (super_admin only)
 */
export const getListAdminReviewScansUrl = (
  params?: ListAdminReviewScansParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/review-scans?${stringifiedParams}`
    : `/api/admin/review-scans`;
};

export const listAdminReviewScans = async (
  params?: ListAdminReviewScansParams,
  options?: RequestInit,
): Promise<AdminReviewScansResponse> => {
  return customFetch<AdminReviewScansResponse>(
    getListAdminReviewScansUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminReviewScansQueryKey = (
  params?: ListAdminReviewScansParams,
) => {
  return [`/api/admin/review-scans`, ...(params ? [params] : [])] as const;
};

export const getListAdminReviewScansQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminReviewScans>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminReviewScansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminReviewScans>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminReviewScansQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminReviewScans>>
  > = ({ signal }) =>
    listAdminReviewScans(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminReviewScans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminReviewScansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminReviewScans>>
>;
export type ListAdminReviewScansQueryError = ErrorType<unknown>;

/**
 * @summary List recent review scan jobs (super_admin only)
 */

export function useListAdminReviewScans<
  TData = Awaited<ReturnType<typeof listAdminReviewScans>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminReviewScansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminReviewScans>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminReviewScansQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single review scan job with per-source error breakdown (super_admin only)
 */
export const getGetAdminReviewScanUrl = (id: string) => {
  return `/api/admin/review-scans/${id}`;
};

export const getAdminReviewScan = async (
  id: string,
  options?: RequestInit,
): Promise<AdminReviewScanDetailResponse> => {
  return customFetch<AdminReviewScanDetailResponse>(
    getGetAdminReviewScanUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminReviewScanQueryKey = (id: string) => {
  return [`/api/admin/review-scans/${id}`] as const;
};

export const getGetAdminReviewScanQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminReviewScan>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReviewScan>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminReviewScanQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminReviewScan>>
  > = ({ signal }) => getAdminReviewScan(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminReviewScan>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminReviewScanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminReviewScan>>
>;
export type GetAdminReviewScanQueryError = ErrorType<unknown>;

/**
 * @summary Get a single review scan job with per-source error breakdown (super_admin only)
 */

export function useGetAdminReviewScan<
  TData = Awaited<ReturnType<typeof getAdminReviewScan>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReviewScan>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminReviewScanQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List CRM sales leads
 */
export const getGetAdminSalesLeadsUrl = (params?: GetAdminSalesLeadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/sales-leads?${stringifiedParams}`
    : `/api/admin/sales-leads`;
};

export const getAdminSalesLeads = async (
  params?: GetAdminSalesLeadsParams,
  options?: RequestInit,
): Promise<AdminSalesLeadsResponse> => {
  return customFetch<AdminSalesLeadsResponse>(
    getGetAdminSalesLeadsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminSalesLeadsQueryKey = (
  params?: GetAdminSalesLeadsParams,
) => {
  return [`/api/admin/sales-leads`, ...(params ? [params] : [])] as const;
};

export const getGetAdminSalesLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminSalesLeads>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminSalesLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSalesLeads>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminSalesLeadsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminSalesLeads>>
  > = ({ signal }) => getAdminSalesLeads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSalesLeads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminSalesLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminSalesLeads>>
>;
export type GetAdminSalesLeadsQueryError = ErrorType<unknown>;

/**
 * @summary List CRM sales leads
 */

export function useGetAdminSalesLeads<
  TData = Awaited<ReturnType<typeof getAdminSalesLeads>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAdminSalesLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSalesLeads>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminSalesLeadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new CRM sales lead manually
 */
export const getCreateAdminSalesLeadUrl = () => {
  return `/api/admin/sales-leads`;
};

export const createAdminSalesLead = async (
  createAdminSalesLeadBody: CreateAdminSalesLeadBody,
  options?: RequestInit,
): Promise<AdminSalesLead> => {
  return customFetch<AdminSalesLead>(getCreateAdminSalesLeadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAdminSalesLeadBody),
  });
};

export const getCreateAdminSalesLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminSalesLead>>,
    TError,
    { data: BodyType<CreateAdminSalesLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminSalesLead>>,
  TError,
  { data: BodyType<CreateAdminSalesLeadBody> },
  TContext
> => {
  const mutationKey = ["createAdminSalesLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminSalesLead>>,
    { data: BodyType<CreateAdminSalesLeadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAdminSalesLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminSalesLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminSalesLead>>
>;
export type CreateAdminSalesLeadMutationBody =
  BodyType<CreateAdminSalesLeadBody>;
export type CreateAdminSalesLeadMutationError = ErrorType<unknown>;

/**
 * @summary Create a new CRM sales lead manually
 */
export const useCreateAdminSalesLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminSalesLead>>,
    TError,
    { data: BodyType<CreateAdminSalesLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAdminSalesLead>>,
  TError,
  { data: BodyType<CreateAdminSalesLeadBody> },
  TContext
> => {
  return useMutation(getCreateAdminSalesLeadMutationOptions(options));
};

/**
 * @summary Update a sales lead's pipeline status
 */
export const getUpdateAdminSalesLeadUrl = (id: string) => {
  return `/api/admin/sales-leads/${id}`;
};

export const updateAdminSalesLead = async (
  id: string,
  updateAdminSalesLeadBody: UpdateAdminSalesLeadBody,
  options?: RequestInit,
): Promise<AdminSalesLead> => {
  return customFetch<AdminSalesLead>(getUpdateAdminSalesLeadUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAdminSalesLeadBody),
  });
};

export const getUpdateAdminSalesLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminSalesLead>>,
    TError,
    { id: string; data: BodyType<UpdateAdminSalesLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminSalesLead>>,
  TError,
  { id: string; data: BodyType<UpdateAdminSalesLeadBody> },
  TContext
> => {
  const mutationKey = ["updateAdminSalesLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminSalesLead>>,
    { id: string; data: BodyType<UpdateAdminSalesLeadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAdminSalesLead(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminSalesLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminSalesLead>>
>;
export type UpdateAdminSalesLeadMutationBody =
  BodyType<UpdateAdminSalesLeadBody>;
export type UpdateAdminSalesLeadMutationError = ErrorType<unknown>;

/**
 * @summary Update a sales lead's pipeline status
 */
export const useUpdateAdminSalesLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminSalesLead>>,
    TError,
    { id: string; data: BodyType<UpdateAdminSalesLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminSalesLead>>,
  TError,
  { id: string; data: BodyType<UpdateAdminSalesLeadBody> },
  TContext
> => {
  return useMutation(getUpdateAdminSalesLeadMutationOptions(options));
};

/**
 * @summary List super-admin staging uploads (super_admin only)
 */
export const getListAdminStagingUploadsUrl = (
  params?: ListAdminStagingUploadsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/uploads?${stringifiedParams}`
    : `/api/admin/uploads`;
};

export const listAdminStagingUploads = async (
  params?: ListAdminStagingUploadsParams,
  options?: RequestInit,
): Promise<AdminStagingUploadsResponse> => {
  return customFetch<AdminStagingUploadsResponse>(
    getListAdminStagingUploadsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminStagingUploadsQueryKey = (
  params?: ListAdminStagingUploadsParams,
) => {
  return [`/api/admin/uploads`, ...(params ? [params] : [])] as const;
};

export const getListAdminStagingUploadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminStagingUploads>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminStagingUploadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStagingUploads>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminStagingUploadsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminStagingUploads>>
  > = ({ signal }) =>
    listAdminStagingUploads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminStagingUploads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminStagingUploadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminStagingUploads>>
>;
export type ListAdminStagingUploadsQueryError = ErrorType<unknown>;

/**
 * @summary List super-admin staging uploads (super_admin only)
 */

export function useListAdminStagingUploads<
  TData = Awaited<ReturnType<typeof listAdminStagingUploads>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminStagingUploadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStagingUploads>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminStagingUploadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a Markdown review file for a target tenant (super_admin only)
 */
export const getCreateAdminStagingUploadUrl = () => {
  return `/api/admin/uploads`;
};

export const createAdminStagingUpload = async (
  createAdminStagingUploadBody: CreateAdminStagingUploadBody,
  options?: RequestInit,
): Promise<AdminStagingUploadCreated> => {
  const formData = new FormData();
  formData.append(`file`, createAdminStagingUploadBody.file);
  formData.append(`orgId`, createAdminStagingUploadBody.orgId);

  return customFetch<AdminStagingUploadCreated>(
    getCreateAdminStagingUploadUrl(),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getCreateAdminStagingUploadMutationOptions = <
  TError = ErrorType<CreateAdminStagingUpload409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminStagingUpload>>,
    TError,
    { data: BodyType<CreateAdminStagingUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminStagingUpload>>,
  TError,
  { data: BodyType<CreateAdminStagingUploadBody> },
  TContext
> => {
  const mutationKey = ["createAdminStagingUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminStagingUpload>>,
    { data: BodyType<CreateAdminStagingUploadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAdminStagingUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminStagingUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminStagingUpload>>
>;
export type CreateAdminStagingUploadMutationBody =
  BodyType<CreateAdminStagingUploadBody>;
export type CreateAdminStagingUploadMutationError =
  ErrorType<CreateAdminStagingUpload409>;

/**
 * @summary Upload a Markdown review file for a target tenant (super_admin only)
 */
export const useCreateAdminStagingUpload = <
  TError = ErrorType<CreateAdminStagingUpload409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminStagingUpload>>,
    TError,
    { data: BodyType<CreateAdminStagingUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAdminStagingUpload>>,
  TError,
  { data: BodyType<CreateAdminStagingUploadBody> },
  TContext
> => {
  return useMutation(getCreateAdminStagingUploadMutationOptions(options));
};

/**
 * @summary Fetch a staging upload with its candidate rows (super_admin only)
 */
export const getGetAdminStagingUploadUrl = (id: string) => {
  return `/api/admin/uploads/${id}`;
};

export const getAdminStagingUpload = async (
  id: string,
  options?: RequestInit,
): Promise<AdminStagingUploadDetail> => {
  return customFetch<AdminStagingUploadDetail>(
    getGetAdminStagingUploadUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminStagingUploadQueryKey = (id: string) => {
  return [`/api/admin/uploads/${id}`] as const;
};

export const getGetAdminStagingUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminStagingUpload>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStagingUpload>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminStagingUploadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminStagingUpload>>
  > = ({ signal }) => getAdminStagingUpload(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminStagingUpload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminStagingUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminStagingUpload>>
>;
export type GetAdminStagingUploadQueryError = ErrorType<unknown>;

/**
 * @summary Fetch a staging upload with its candidate rows (super_admin only)
 */

export function useGetAdminStagingUpload<
  TData = Awaited<ReturnType<typeof getAdminStagingUpload>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStagingUpload>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminStagingUploadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Edit or discard a single candidate review (super_admin only)
 */
export const getUpdateAdminStagingUploadReviewUrl = (
  id: string,
  reviewId: string,
) => {
  return `/api/admin/uploads/${id}/reviews/${reviewId}`;
};

export const updateAdminStagingUploadReview = async (
  id: string,
  reviewId: string,
  updateAdminStagingUploadReviewBody: UpdateAdminStagingUploadReviewBody,
  options?: RequestInit,
): Promise<UpdateAdminStagingUploadReview200> => {
  return customFetch<UpdateAdminStagingUploadReview200>(
    getUpdateAdminStagingUploadReviewUrl(id, reviewId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateAdminStagingUploadReviewBody),
    },
  );
};

export const getUpdateAdminStagingUploadReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminStagingUploadReview>>,
    TError,
    {
      id: string;
      reviewId: string;
      data: BodyType<UpdateAdminStagingUploadReviewBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminStagingUploadReview>>,
  TError,
  {
    id: string;
    reviewId: string;
    data: BodyType<UpdateAdminStagingUploadReviewBody>;
  },
  TContext
> => {
  const mutationKey = ["updateAdminStagingUploadReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminStagingUploadReview>>,
    {
      id: string;
      reviewId: string;
      data: BodyType<UpdateAdminStagingUploadReviewBody>;
    }
  > = (props) => {
    const { id, reviewId, data } = props ?? {};

    return updateAdminStagingUploadReview(id, reviewId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminStagingUploadReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminStagingUploadReview>>
>;
export type UpdateAdminStagingUploadReviewMutationBody =
  BodyType<UpdateAdminStagingUploadReviewBody>;
export type UpdateAdminStagingUploadReviewMutationError = ErrorType<unknown>;

/**
 * @summary Edit or discard a single candidate review (super_admin only)
 */
export const useUpdateAdminStagingUploadReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminStagingUploadReview>>,
    TError,
    {
      id: string;
      reviewId: string;
      data: BodyType<UpdateAdminStagingUploadReviewBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminStagingUploadReview>>,
  TError,
  {
    id: string;
    reviewId: string;
    data: BodyType<UpdateAdminStagingUploadReviewBody>;
  },
  TContext
> => {
  return useMutation(getUpdateAdminStagingUploadReviewMutationOptions(options));
};

/**
 * @summary Commit non-discarded candidates to reviews (super_admin only)
 */
export const getApproveAdminStagingUploadUrl = (id: string) => {
  return `/api/admin/uploads/${id}/approve`;
};

export const approveAdminStagingUpload = async (
  id: string,
  approveAdminStagingUploadBody?: ApproveAdminStagingUploadBody,
  options?: RequestInit,
): Promise<AdminStagingUploadApproval> => {
  return customFetch<AdminStagingUploadApproval>(
    getApproveAdminStagingUploadUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(approveAdminStagingUploadBody),
    },
  );
};

export const getApproveAdminStagingUploadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveAdminStagingUpload>>,
    TError,
    { id: string; data: BodyType<ApproveAdminStagingUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveAdminStagingUpload>>,
  TError,
  { id: string; data: BodyType<ApproveAdminStagingUploadBody> },
  TContext
> => {
  const mutationKey = ["approveAdminStagingUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveAdminStagingUpload>>,
    { id: string; data: BodyType<ApproveAdminStagingUploadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveAdminStagingUpload(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveAdminStagingUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveAdminStagingUpload>>
>;
export type ApproveAdminStagingUploadMutationBody =
  BodyType<ApproveAdminStagingUploadBody>;
export type ApproveAdminStagingUploadMutationError = ErrorType<unknown>;

/**
 * @summary Commit non-discarded candidates to reviews (super_admin only)
 */
export const useApproveAdminStagingUpload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveAdminStagingUpload>>,
    TError,
    { id: string; data: BodyType<ApproveAdminStagingUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveAdminStagingUpload>>,
  TError,
  { id: string; data: BodyType<ApproveAdminStagingUploadBody> },
  TContext
> => {
  return useMutation(getApproveAdminStagingUploadMutationOptions(options));
};

/**
 * @summary Discard a staging upload without writing reviews (super_admin only)
 */
export const getRejectAdminStagingUploadUrl = (id: string) => {
  return `/api/admin/uploads/${id}/reject`;
};

export const rejectAdminStagingUpload = async (
  id: string,
  rejectAdminStagingUploadBody?: RejectAdminStagingUploadBody,
  options?: RequestInit,
): Promise<RejectAdminStagingUpload200> => {
  return customFetch<RejectAdminStagingUpload200>(
    getRejectAdminStagingUploadUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rejectAdminStagingUploadBody),
    },
  );
};

export const getRejectAdminStagingUploadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectAdminStagingUpload>>,
    TError,
    { id: string; data: BodyType<RejectAdminStagingUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectAdminStagingUpload>>,
  TError,
  { id: string; data: BodyType<RejectAdminStagingUploadBody> },
  TContext
> => {
  const mutationKey = ["rejectAdminStagingUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectAdminStagingUpload>>,
    { id: string; data: BodyType<RejectAdminStagingUploadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectAdminStagingUpload(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectAdminStagingUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectAdminStagingUpload>>
>;
export type RejectAdminStagingUploadMutationBody =
  BodyType<RejectAdminStagingUploadBody>;
export type RejectAdminStagingUploadMutationError = ErrorType<unknown>;

/**
 * @summary Discard a staging upload without writing reviews (super_admin only)
 */
export const useRejectAdminStagingUpload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectAdminStagingUpload>>,
    TError,
    { id: string; data: BodyType<RejectAdminStagingUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectAdminStagingUpload>>,
  TError,
  { id: string; data: BodyType<RejectAdminStagingUploadBody> },
  TContext
> => {
  return useMutation(getRejectAdminStagingUploadMutationOptions(options));
};

/**
 * @summary List AI Upload history rows for one tenant (super_admin only)
 */
export const getListAdminAiUploadsUrl = (params: ListAdminAiUploadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/ai-uploads?${stringifiedParams}`
    : `/api/admin/ai-uploads`;
};

export const listAdminAiUploads = async (
  params: ListAdminAiUploadsParams,
  options?: RequestInit,
): Promise<AdminAiUploadsResponse> => {
  return customFetch<AdminAiUploadsResponse>(getListAdminAiUploadsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAdminAiUploadsQueryKey = (
  params?: ListAdminAiUploadsParams,
) => {
  return [`/api/admin/ai-uploads`, ...(params ? [params] : [])] as const;
};

export const getListAdminAiUploadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAiUploads>>,
  TError = ErrorType<unknown>,
>(
  params: ListAdminAiUploadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAiUploads>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminAiUploadsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminAiUploads>>
  > = ({ signal }) => listAdminAiUploads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminAiUploads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminAiUploadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAiUploads>>
>;
export type ListAdminAiUploadsQueryError = ErrorType<unknown>;

/**
 * @summary List AI Upload history rows for one tenant (super_admin only)
 */

export function useListAdminAiUploads<
  TData = Awaited<ReturnType<typeof listAdminAiUploads>>,
  TError = ErrorType<unknown>,
>(
  params: ListAdminAiUploadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAiUploads>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminAiUploadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Fetch one AI Upload with all its extracted reviews (super_admin only)
 */
export const getGetAdminAiUploadUrl = (id: string) => {
  return `/api/admin/ai-uploads/${id}`;
};

export const getAdminAiUpload = async (
  id: string,
  options?: RequestInit,
): Promise<AdminAiUploadDetail> => {
  return customFetch<AdminAiUploadDetail>(getGetAdminAiUploadUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminAiUploadQueryKey = (id: string) => {
  return [`/api/admin/ai-uploads/${id}`] as const;
};

export const getGetAdminAiUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminAiUpload>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUpload>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminAiUploadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminAiUpload>>
  > = ({ signal }) => getAdminAiUpload(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAiUpload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminAiUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminAiUpload>>
>;
export type GetAdminAiUploadQueryError = ErrorType<unknown>;

/**
 * @summary Fetch one AI Upload with all its extracted reviews (super_admin only)
 */

export function useGetAdminAiUpload<
  TData = Awaited<ReturnType<typeof getAdminAiUpload>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAiUpload>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminAiUploadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Approve one or more pending reviews from an AI Upload (super_admin only)
 */
export const getApproveAdminAiUploadReviewsUrl = (id: string) => {
  return `/api/admin/ai-uploads/${id}/approve`;
};

export const approveAdminAiUploadReviews = async (
  id: string,
  approveAdminAiUploadReviewsBody: ApproveAdminAiUploadReviewsBody,
  options?: RequestInit,
): Promise<AdminAiUploadApprovalResult> => {
  return customFetch<AdminAiUploadApprovalResult>(
    getApproveAdminAiUploadReviewsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(approveAdminAiUploadReviewsBody),
    },
  );
};

export const getApproveAdminAiUploadReviewsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveAdminAiUploadReviews>>,
    TError,
    { id: string; data: BodyType<ApproveAdminAiUploadReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveAdminAiUploadReviews>>,
  TError,
  { id: string; data: BodyType<ApproveAdminAiUploadReviewsBody> },
  TContext
> => {
  const mutationKey = ["approveAdminAiUploadReviews"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveAdminAiUploadReviews>>,
    { id: string; data: BodyType<ApproveAdminAiUploadReviewsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveAdminAiUploadReviews(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveAdminAiUploadReviewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveAdminAiUploadReviews>>
>;
export type ApproveAdminAiUploadReviewsMutationBody =
  BodyType<ApproveAdminAiUploadReviewsBody>;
export type ApproveAdminAiUploadReviewsMutationError = ErrorType<unknown>;

/**
 * @summary Approve one or more pending reviews from an AI Upload (super_admin only)
 */
export const useApproveAdminAiUploadReviews = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveAdminAiUploadReviews>>,
    TError,
    { id: string; data: BodyType<ApproveAdminAiUploadReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveAdminAiUploadReviews>>,
  TError,
  { id: string; data: BodyType<ApproveAdminAiUploadReviewsBody> },
  TContext
> => {
  return useMutation(getApproveAdminAiUploadReviewsMutationOptions(options));
};

/**
 * @summary Reject (delete) one or more reviews from an AI Upload (super_admin only)
 */
export const getRejectAdminAiUploadReviewsUrl = (id: string) => {
  return `/api/admin/ai-uploads/${id}/reject`;
};

export const rejectAdminAiUploadReviews = async (
  id: string,
  rejectAdminAiUploadReviewsBody: RejectAdminAiUploadReviewsBody,
  options?: RequestInit,
): Promise<AdminAiUploadRejectionResult> => {
  return customFetch<AdminAiUploadRejectionResult>(
    getRejectAdminAiUploadReviewsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rejectAdminAiUploadReviewsBody),
    },
  );
};

export const getRejectAdminAiUploadReviewsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectAdminAiUploadReviews>>,
    TError,
    { id: string; data: BodyType<RejectAdminAiUploadReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectAdminAiUploadReviews>>,
  TError,
  { id: string; data: BodyType<RejectAdminAiUploadReviewsBody> },
  TContext
> => {
  const mutationKey = ["rejectAdminAiUploadReviews"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectAdminAiUploadReviews>>,
    { id: string; data: BodyType<RejectAdminAiUploadReviewsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectAdminAiUploadReviews(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectAdminAiUploadReviewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectAdminAiUploadReviews>>
>;
export type RejectAdminAiUploadReviewsMutationBody =
  BodyType<RejectAdminAiUploadReviewsBody>;
export type RejectAdminAiUploadReviewsMutationError = ErrorType<unknown>;

/**
 * @summary Reject (delete) one or more reviews from an AI Upload (super_admin only)
 */
export const useRejectAdminAiUploadReviews = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectAdminAiUploadReviews>>,
    TError,
    { id: string; data: BodyType<RejectAdminAiUploadReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectAdminAiUploadReviews>>,
  TError,
  { id: string; data: BodyType<RejectAdminAiUploadReviewsBody> },
  TContext
> => {
  return useMutation(getRejectAdminAiUploadReviewsMutationOptions(options));
};

/**
 * @summary Undo a previous approve/reject decision for one or more AI Upload rows (super_admin only)
 */
export const getUndoAdminAiUploadReviewsUrl = (id: string) => {
  return `/api/admin/ai-uploads/${id}/undo`;
};

export const undoAdminAiUploadReviews = async (
  id: string,
  undoAdminAiUploadReviewsBody: UndoAdminAiUploadReviewsBody,
  options?: RequestInit,
): Promise<AdminAiUploadUndoResult> => {
  return customFetch<AdminAiUploadUndoResult>(
    getUndoAdminAiUploadReviewsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(undoAdminAiUploadReviewsBody),
    },
  );
};

export const getUndoAdminAiUploadReviewsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoAdminAiUploadReviews>>,
    TError,
    { id: string; data: BodyType<UndoAdminAiUploadReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof undoAdminAiUploadReviews>>,
  TError,
  { id: string; data: BodyType<UndoAdminAiUploadReviewsBody> },
  TContext
> => {
  const mutationKey = ["undoAdminAiUploadReviews"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof undoAdminAiUploadReviews>>,
    { id: string; data: BodyType<UndoAdminAiUploadReviewsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return undoAdminAiUploadReviews(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UndoAdminAiUploadReviewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof undoAdminAiUploadReviews>>
>;
export type UndoAdminAiUploadReviewsMutationBody =
  BodyType<UndoAdminAiUploadReviewsBody>;
export type UndoAdminAiUploadReviewsMutationError = ErrorType<unknown>;

/**
 * @summary Undo a previous approve/reject decision for one or more AI Upload rows (super_admin only)
 */
export const useUndoAdminAiUploadReviews = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoAdminAiUploadReviews>>,
    TError,
    { id: string; data: BodyType<UndoAdminAiUploadReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof undoAdminAiUploadReviews>>,
  TError,
  { id: string; data: BodyType<UndoAdminAiUploadReviewsBody> },
  TContext
> => {
  return useMutation(getUndoAdminAiUploadReviewsMutationOptions(options));
};

/**
 * @summary Re-run the AI extractor on the original uploaded file (super_admin only)
 */
export const getReExtractAdminAiUploadUrl = (id: string) => {
  return `/api/admin/ai-uploads/${id}/re-extract`;
};

export const reExtractAdminAiUpload = async (
  id: string,
  options?: RequestInit,
): Promise<AdminAiUploadReExtractResult> => {
  return customFetch<AdminAiUploadReExtractResult>(
    getReExtractAdminAiUploadUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getReExtractAdminAiUploadMutationOptions = <
  TError = ErrorType<ReExtractAdminAiUpload409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reExtractAdminAiUpload>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reExtractAdminAiUpload>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["reExtractAdminAiUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reExtractAdminAiUpload>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return reExtractAdminAiUpload(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReExtractAdminAiUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof reExtractAdminAiUpload>>
>;

export type ReExtractAdminAiUploadMutationError =
  ErrorType<ReExtractAdminAiUpload409>;

/**
 * @summary Re-run the AI extractor on the original uploaded file (super_admin only)
 */
export const useReExtractAdminAiUpload = <
  TError = ErrorType<ReExtractAdminAiUpload409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reExtractAdminAiUpload>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reExtractAdminAiUpload>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getReExtractAdminAiUploadMutationOptions(options));
};

/**
 * Reads a Markdown file produced by an AI search/research tool, runs
the shared markdown-mode review extractor, and queues the
resulting reviews against the target tenant under status
`pending_review`. They are NOT visible to the tenant until the
super-admin approves them in the AI Upload approval queue.

 * @summary Ingest an AI-generated Markdown review dump for a tenant (super_admin only)
 */
export const getCreateAdminAiUploadUrl = () => {
  return `/api/admin/ai-upload`;
};

export const createAdminAiUpload = async (
  createAdminAiUploadBody: CreateAdminAiUploadBody,
  options?: RequestInit,
): Promise<AdminAiUploadResult> => {
  const formData = new FormData();
  formData.append(`file`, createAdminAiUploadBody.file);
  formData.append(`orgId`, createAdminAiUploadBody.orgId);

  return customFetch<AdminAiUploadResult>(getCreateAdminAiUploadUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getCreateAdminAiUploadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminAiUpload>>,
    TError,
    { data: BodyType<CreateAdminAiUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminAiUpload>>,
  TError,
  { data: BodyType<CreateAdminAiUploadBody> },
  TContext
> => {
  const mutationKey = ["createAdminAiUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminAiUpload>>,
    { data: BodyType<CreateAdminAiUploadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAdminAiUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminAiUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminAiUpload>>
>;
export type CreateAdminAiUploadMutationBody = BodyType<CreateAdminAiUploadBody>;
export type CreateAdminAiUploadMutationError = ErrorType<void>;

/**
 * @summary Ingest an AI-generated Markdown review dump for a tenant (super_admin only)
 */
export const useCreateAdminAiUpload = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminAiUpload>>,
    TError,
    { data: BodyType<CreateAdminAiUploadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAdminAiUpload>>,
  TError,
  { data: BodyType<CreateAdminAiUploadBody> },
  TContext
> => {
  return useMutation(getCreateAdminAiUploadMutationOptions(options));
};

/**
 * Returns a presigned GCS URL for direct upload. The client sends JSON
metadata here, then uploads the file directly to the returned URL.

 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<StorageErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<StorageErrorEnvelope>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<StorageErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * Inspects the bytes already uploaded to the presigned URL and verifies the
leading magic bytes match a supported image format (PNG, JPEG, GIF, WebP).
If the bytes don't match, the object is deleted from storage and a 400 is
returned. This is defence-in-depth against a client that lies about
Content-Type at upload time.

 * @summary Validate that an uploaded object is a real image
 */
export const getFinalizeImageUploadUrl = () => {
  return `/api/storage/uploads/finalize-image`;
};

export const finalizeImageUpload = async (
  finalizeImageUploadRequest: FinalizeImageUploadRequest,
  options?: RequestInit,
): Promise<FinalizeImageUploadResponse> => {
  return customFetch<FinalizeImageUploadResponse>(getFinalizeImageUploadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(finalizeImageUploadRequest),
  });
};

export const getFinalizeImageUploadMutationOptions = <
  TError = ErrorType<StorageErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeImageUpload>>,
    TError,
    { data: BodyType<FinalizeImageUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeImageUpload>>,
  TError,
  { data: BodyType<FinalizeImageUploadRequest> },
  TContext
> => {
  const mutationKey = ["finalizeImageUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeImageUpload>>,
    { data: BodyType<FinalizeImageUploadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return finalizeImageUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeImageUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeImageUpload>>
>;
export type FinalizeImageUploadMutationBody =
  BodyType<FinalizeImageUploadRequest>;
export type FinalizeImageUploadMutationError = ErrorType<StorageErrorEnvelope>;

/**
 * @summary Validate that an uploaded object is a real image
 */
export const useFinalizeImageUpload = <
  TError = ErrorType<StorageErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeImageUpload>>,
    TError,
    { data: BodyType<FinalizeImageUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof finalizeImageUpload>>,
  TError,
  { data: BodyType<FinalizeImageUploadRequest> },
  TContext
> => {
  return useMutation(getFinalizeImageUploadMutationOptions(options));
};

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getGetPublicObjectUrl = (filePath: string) => {
  return `/api/storage/public-objects/${filePath}`;
};

export const getPublicObject = async (
  filePath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetPublicObjectUrl(filePath), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicObjectQueryKey = (filePath: string) => {
  return [`/api/storage/public-objects/${filePath}`] as const;
};

export const getGetPublicObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<StorageErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({
    signal,
  }) => getPublicObject(filePath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!filePath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicObject>>
>;
export type GetPublicObjectQueryError = ErrorType<StorageErrorEnvelope>;

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<StorageErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicObjectQueryOptions(filePath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<StorageErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<StorageErrorEnvelope>;

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<StorageErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Startup/readiness probe. Returns 200 when the server is up and the
database is reachable, and 503 when the database connection fails so
monitoring or deployment tooling can detect crashes immediately.

 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<HealthStatus>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<HealthStatus>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<HealthStatus>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get current user
 */
export const getGetCurrentAuthUserUrl = () => {
  return `/api/auth/user`;
};

export const getCurrentAuthUser = async (
  options?: RequestInit,
): Promise<GetCurrentAuthUserResponse> => {
  return customFetch<GetCurrentAuthUserResponse>(getGetCurrentAuthUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentAuthUserQueryKey = () => {
  return [`/api/auth/user`] as const;
};

export const getGetCurrentAuthUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentAuthUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentAuthUserQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentAuthUser>>
  > = ({ signal }) => getCurrentAuthUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentAuthUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentAuthUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentAuthUser>>
>;
export type GetCurrentAuthUserQueryError = ErrorType<unknown>;

/**
 * @summary Get current user
 */

export function useGetCurrentAuthUser<
  TData = Awaited<ReturnType<typeof getCurrentAuthUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAuthUser>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentAuthUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Resolve Firebase tenant by email
 */
export const getGetAuthTenantUrl = (params: GetAuthTenantParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/auth/tenant?${stringifiedParams}`
    : `/api/auth/tenant`;
};

export const getAuthTenant = async (
  params: GetAuthTenantParams,
  options?: RequestInit,
): Promise<AuthTenantResponse> => {
  return customFetch<AuthTenantResponse>(getGetAuthTenantUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAuthTenantQueryKey = (params?: GetAuthTenantParams) => {
  return [`/api/auth/tenant`, ...(params ? [params] : [])] as const;
};

export const getGetAuthTenantQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthTenant>>,
  TError = ErrorType<void>,
>(
  params: GetAuthTenantParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthTenant>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthTenantQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthTenant>>> = ({
    signal,
  }) => getAuthTenant(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthTenant>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuthTenantQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthTenant>>
>;
export type GetAuthTenantQueryError = ErrorType<void>;

/**
 * @summary Resolve Firebase tenant by email
 */

export function useGetAuthTenant<
  TData = Awaited<ReturnType<typeof getAuthTenant>>,
  TError = ErrorType<void>,
>(
  params: GetAuthTenantParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthTenant>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAuthTenantQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Verify Firebase ID token and create session
 */
export const getVerifyFirebaseTokenUrl = () => {
  return `/api/auth/verify-token`;
};

export const verifyFirebaseToken = async (
  verifyFirebaseTokenBody: VerifyFirebaseTokenBody,
  options?: RequestInit,
): Promise<VerifyFirebaseTokenResponse> => {
  return customFetch<VerifyFirebaseTokenResponse>(getVerifyFirebaseTokenUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(verifyFirebaseTokenBody),
  });
};

export const getVerifyFirebaseTokenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyFirebaseToken>>,
    TError,
    { data: BodyType<VerifyFirebaseTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyFirebaseToken>>,
  TError,
  { data: BodyType<VerifyFirebaseTokenBody> },
  TContext
> => {
  const mutationKey = ["verifyFirebaseToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyFirebaseToken>>,
    { data: BodyType<VerifyFirebaseTokenBody> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyFirebaseToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyFirebaseTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyFirebaseToken>>
>;
export type VerifyFirebaseTokenMutationBody = BodyType<VerifyFirebaseTokenBody>;
export type VerifyFirebaseTokenMutationError = ErrorType<void>;

/**
 * @summary Verify Firebase ID token and create session
 */
export const useVerifyFirebaseToken = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyFirebaseToken>>,
    TError,
    { data: BodyType<VerifyFirebaseTokenBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyFirebaseToken>>,
  TError,
  { data: BodyType<VerifyFirebaseTokenBody> },
  TContext
> => {
  return useMutation(getVerifyFirebaseTokenMutationOptions(options));
};

/**
 * @summary Logout
 */
export const getLogoutRedirectUrl = () => {
  return `/api/logout`;
};

export const logoutRedirect = async (
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getLogoutRedirectUrl(), {
    ...options,
    method: "GET",
  });
};

export const getLogoutRedirectQueryKey = () => {
  return [`/api/logout`] as const;
};

export const getLogoutRedirectQueryOptions = <
  TData = Awaited<ReturnType<typeof logoutRedirect>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutRedirect>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLogoutRedirectQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof logoutRedirect>>> = ({
    signal,
  }) => logoutRedirect({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof logoutRedirect>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LogoutRedirectQueryResult = NonNullable<
  Awaited<ReturnType<typeof logoutRedirect>>
>;
export type LogoutRedirectQueryError = ErrorType<void>;

/**
 * @summary Logout
 */

export function useLogoutRedirect<
  TData = Awaited<ReturnType<typeof logoutRedirect>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutRedirect>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLogoutRedirectQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get executive dashboard data
 */
export const getGetDashboardUrl = () => {
  return `/api/dashboard`;
};

export const getDashboard = async (
  options?: RequestInit,
): Promise<DashboardData> => {
  return customFetch<DashboardData>(getGetDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardQueryKey = () => {
  return [`/api/dashboard`] as const;
};

export const getGetDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({
    signal,
  }) => getDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboard>>
>;
export type GetDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Get executive dashboard data
 */

export function useGetDashboard<
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get time-series trend data for a KPI
 */
export const getGetKpiTrendsUrl = (params: GetKpiTrendsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/kpi-trends?${stringifiedParams}`
    : `/api/dashboard/kpi-trends`;
};

export const getKpiTrends = async (
  params: GetKpiTrendsParams,
  options?: RequestInit,
): Promise<KpiTrendsResponse> => {
  return customFetch<KpiTrendsResponse>(getGetKpiTrendsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetKpiTrendsQueryKey = (params?: GetKpiTrendsParams) => {
  return [`/api/dashboard/kpi-trends`, ...(params ? [params] : [])] as const;
};

export const getGetKpiTrendsQueryOptions = <
  TData = Awaited<ReturnType<typeof getKpiTrends>>,
  TError = ErrorType<unknown>,
>(
  params: GetKpiTrendsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKpiTrends>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKpiTrendsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKpiTrends>>> = ({
    signal,
  }) => getKpiTrends(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKpiTrends>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetKpiTrendsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKpiTrends>>
>;
export type GetKpiTrendsQueryError = ErrorType<unknown>;

/**
 * @summary Get time-series trend data for a KPI
 */

export function useGetKpiTrends<
  TData = Awaited<ReturnType<typeof getKpiTrends>>,
  TError = ErrorType<unknown>,
>(
  params: GetKpiTrendsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKpiTrends>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetKpiTrendsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get AI-generated analysis of a KPI trend
 */
export const getGetKpiTrendAnalysisUrl = (
  params: GetKpiTrendAnalysisParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/kpi-trends/analysis?${stringifiedParams}`
    : `/api/dashboard/kpi-trends/analysis`;
};

export const getKpiTrendAnalysis = async (
  params: GetKpiTrendAnalysisParams,
  options?: RequestInit,
): Promise<KpiTrendAnalysisResponse> => {
  return customFetch<KpiTrendAnalysisResponse>(
    getGetKpiTrendAnalysisUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetKpiTrendAnalysisQueryKey = (
  params?: GetKpiTrendAnalysisParams,
) => {
  return [
    `/api/dashboard/kpi-trends/analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetKpiTrendAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getKpiTrendAnalysis>>,
  TError = ErrorType<unknown>,
>(
  params: GetKpiTrendAnalysisParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKpiTrendAnalysis>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetKpiTrendAnalysisQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getKpiTrendAnalysis>>
  > = ({ signal }) =>
    getKpiTrendAnalysis(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKpiTrendAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetKpiTrendAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKpiTrendAnalysis>>
>;
export type GetKpiTrendAnalysisQueryError = ErrorType<unknown>;

/**
 * @summary Get AI-generated analysis of a KPI trend
 */

export function useGetKpiTrendAnalysis<
  TData = Awaited<ReturnType<typeof getKpiTrendAnalysis>>,
  TError = ErrorType<unknown>,
>(
  params: GetKpiTrendAnalysisParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKpiTrendAnalysis>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetKpiTrendAnalysisQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List departments
 */
export const getListDepartmentsUrl = () => {
  return `/api/departments`;
};

export const listDepartments = async (
  options?: RequestInit,
): Promise<Department[]> => {
  return customFetch<Department[]>(getListDepartmentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDepartmentsQueryKey = () => {
  return [`/api/departments`] as const;
};

export const getListDepartmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDepartments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDepartmentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDepartments>>> = ({
    signal,
  }) => listDepartments({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDepartments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDepartmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDepartments>>
>;
export type ListDepartmentsQueryError = ErrorType<unknown>;

/**
 * @summary List departments
 */

export function useListDepartments<
  TData = Awaited<ReturnType<typeof listDepartments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDepartmentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get department dashboard
 */
export const getGetDepartmentUrl = (id: string) => {
  return `/api/departments/${id}`;
};

export const getDepartment = async (
  id: string,
  options?: RequestInit,
): Promise<DepartmentDashboard> => {
  return customFetch<DepartmentDashboard>(getGetDepartmentUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetDepartmentQueryKey = (id: string) => {
  return [`/api/departments/${id}`] as const;
};

export const getGetDepartmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepartment>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDepartmentQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartment>>> = ({
    signal,
  }) => getDepartment(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDepartment>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDepartmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepartment>>
>;
export type GetDepartmentQueryError = ErrorType<unknown>;

/**
 * @summary Get department dashboard
 */

export function useGetDepartment<
  TData = Awaited<ReturnType<typeof getDepartment>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDepartmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Generates a concise, LLM-powered briefing summarising the highest-impact recent feedback, top open actions, and key topics for the chosen department.

 * @summary Generate an AI briefing for a department
 */
export const getGenerateDepartmentAiBriefingUrl = (
  id: string,
  params?: GenerateDepartmentAiBriefingParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/departments/${id}/ai-briefing?${stringifiedParams}`
    : `/api/departments/${id}/ai-briefing`;
};

export const generateDepartmentAiBriefing = async (
  id: string,
  params?: GenerateDepartmentAiBriefingParams,
  options?: RequestInit,
): Promise<DepartmentBriefingResponse> => {
  return customFetch<DepartmentBriefingResponse>(
    getGenerateDepartmentAiBriefingUrl(id, params),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getGenerateDepartmentAiBriefingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDepartmentAiBriefing>>,
    TError,
    { id: string; params?: GenerateDepartmentAiBriefingParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDepartmentAiBriefing>>,
  TError,
  { id: string; params?: GenerateDepartmentAiBriefingParams },
  TContext
> => {
  const mutationKey = ["generateDepartmentAiBriefing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDepartmentAiBriefing>>,
    { id: string; params?: GenerateDepartmentAiBriefingParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return generateDepartmentAiBriefing(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDepartmentAiBriefingMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDepartmentAiBriefing>>
>;

export type GenerateDepartmentAiBriefingMutationError = ErrorType<unknown>;

/**
 * @summary Generate an AI briefing for a department
 */
export const useGenerateDepartmentAiBriefing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDepartmentAiBriefing>>,
    TError,
    { id: string; params?: GenerateDepartmentAiBriefingParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateDepartmentAiBriefing>>,
  TError,
  { id: string; params?: GenerateDepartmentAiBriefingParams },
  TContext
> => {
  return useMutation(getGenerateDepartmentAiBriefingMutationOptions(options));
};

/**
 * @summary Get time-series trend data for a department KPI
 */
export const getGetDepartmentKpiTrendsUrl = (
  id: string,
  params: GetDepartmentKpiTrendsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/departments/${id}/kpi-trends?${stringifiedParams}`
    : `/api/departments/${id}/kpi-trends`;
};

export const getDepartmentKpiTrends = async (
  id: string,
  params: GetDepartmentKpiTrendsParams,
  options?: RequestInit,
): Promise<KpiTrendsResponse> => {
  return customFetch<KpiTrendsResponse>(
    getGetDepartmentKpiTrendsUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDepartmentKpiTrendsQueryKey = (
  id: string,
  params?: GetDepartmentKpiTrendsParams,
) => {
  return [
    `/api/departments/${id}/kpi-trends`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDepartmentKpiTrendsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepartmentKpiTrends>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetDepartmentKpiTrendsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentKpiTrends>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDepartmentKpiTrendsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDepartmentKpiTrends>>
  > = ({ signal }) =>
    getDepartmentKpiTrends(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDepartmentKpiTrends>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDepartmentKpiTrendsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepartmentKpiTrends>>
>;
export type GetDepartmentKpiTrendsQueryError = ErrorType<unknown>;

/**
 * @summary Get time-series trend data for a department KPI
 */

export function useGetDepartmentKpiTrends<
  TData = Awaited<ReturnType<typeof getDepartmentKpiTrends>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetDepartmentKpiTrendsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentKpiTrends>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDepartmentKpiTrendsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get AI-generated analysis of a department KPI trend
 */
export const getGetDepartmentKpiTrendAnalysisUrl = (
  id: string,
  params: GetDepartmentKpiTrendAnalysisParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/departments/${id}/kpi-trends/analysis?${stringifiedParams}`
    : `/api/departments/${id}/kpi-trends/analysis`;
};

export const getDepartmentKpiTrendAnalysis = async (
  id: string,
  params: GetDepartmentKpiTrendAnalysisParams,
  options?: RequestInit,
): Promise<KpiTrendAnalysisResponse> => {
  return customFetch<KpiTrendAnalysisResponse>(
    getGetDepartmentKpiTrendAnalysisUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDepartmentKpiTrendAnalysisQueryKey = (
  id: string,
  params?: GetDepartmentKpiTrendAnalysisParams,
) => {
  return [
    `/api/departments/${id}/kpi-trends/analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDepartmentKpiTrendAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepartmentKpiTrendAnalysis>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetDepartmentKpiTrendAnalysisParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentKpiTrendAnalysis>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDepartmentKpiTrendAnalysisQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDepartmentKpiTrendAnalysis>>
  > = ({ signal }) =>
    getDepartmentKpiTrendAnalysis(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDepartmentKpiTrendAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDepartmentKpiTrendAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepartmentKpiTrendAnalysis>>
>;
export type GetDepartmentKpiTrendAnalysisQueryError = ErrorType<unknown>;

/**
 * @summary Get AI-generated analysis of a department KPI trend
 */

export function useGetDepartmentKpiTrendAnalysis<
  TData = Awaited<ReturnType<typeof getDepartmentKpiTrendAnalysis>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetDepartmentKpiTrendAnalysisParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentKpiTrendAnalysis>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDepartmentKpiTrendAnalysisQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List reviews with filtering and pagination
 */
export const getListReviewsUrl = (params?: ListReviewsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/reviews?${stringifiedParams}`
    : `/api/reviews`;
};

export const listReviews = async (
  params?: ListReviewsParams,
  options?: RequestInit,
): Promise<ReviewsListResponse> => {
  return customFetch<ReviewsListResponse>(getListReviewsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListReviewsQueryKey = (params?: ListReviewsParams) => {
  return [`/api/reviews`, ...(params ? [params] : [])] as const;
};

export const getListReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof listReviews>>,
  TError = ErrorType<unknown>,
>(
  params?: ListReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listReviews>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListReviewsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listReviews>>> = ({
    signal,
  }) => listReviews(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReviews>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListReviewsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReviews>>
>;
export type ListReviewsQueryError = ErrorType<unknown>;

/**
 * @summary List reviews with filtering and pagination
 */

export function useListReviews<
  TData = Awaited<ReturnType<typeof listReviews>>,
  TError = ErrorType<unknown>,
>(
  params?: ListReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listReviews>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListReviewsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the status of a review (active, archived, invalid)
 */
export const getUpdateReviewStatusUrl = (id: string) => {
  return `/api/reviews/${id}/status`;
};

export const updateReviewStatus = async (
  id: string,
  updateReviewStatusBody: UpdateReviewStatusBody,
  options?: RequestInit,
): Promise<ReviewItem> => {
  return customFetch<ReviewItem>(getUpdateReviewStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateReviewStatusBody),
  });
};

export const getUpdateReviewStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReviewStatus>>,
    TError,
    { id: string; data: BodyType<UpdateReviewStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReviewStatus>>,
  TError,
  { id: string; data: BodyType<UpdateReviewStatusBody> },
  TContext
> => {
  const mutationKey = ["updateReviewStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReviewStatus>>,
    { id: string; data: BodyType<UpdateReviewStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateReviewStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReviewStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReviewStatus>>
>;
export type UpdateReviewStatusMutationBody = BodyType<UpdateReviewStatusBody>;
export type UpdateReviewStatusMutationError = ErrorType<unknown>;

/**
 * @summary Update the status of a review (active, archived, invalid)
 */
export const useUpdateReviewStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReviewStatus>>,
    TError,
    { id: string; data: BodyType<UpdateReviewStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReviewStatus>>,
  TError,
  { id: string; data: BodyType<UpdateReviewStatusBody> },
  TContext
> => {
  return useMutation(getUpdateReviewStatusMutationOptions(options));
};

/**
 * @summary List distinct review branch names
 */
export const getGetBranchesUrl = () => {
  return `/api/reviews/branches`;
};

export const getBranches = async (
  options?: RequestInit,
): Promise<GetBranches200> => {
  return customFetch<GetBranches200>(getGetBranchesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBranchesQueryKey = () => {
  return [`/api/reviews/branches`] as const;
};

export const getGetBranchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBranches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranches>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBranchesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranches>>> = ({
    signal,
  }) => getBranches({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBranches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBranchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBranches>>
>;
export type GetBranchesQueryError = ErrorType<unknown>;

/**
 * @summary List distinct review branch names
 */

export function useGetBranches<
  TData = Awaited<ReturnType<typeof getBranches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranches>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBranchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List feedback topics
 */
export const getListTopicsUrl = (params?: ListTopicsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/topics?${stringifiedParams}`
    : `/api/topics`;
};

export const listTopics = async (
  params?: ListTopicsParams,
  options?: RequestInit,
): Promise<TopicsListResponse> => {
  return customFetch<TopicsListResponse>(getListTopicsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTopicsQueryKey = (params?: ListTopicsParams) => {
  return [`/api/topics`, ...(params ? [params] : [])] as const;
};

export const getListTopicsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTopics>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTopicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopics>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTopicsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTopics>>> = ({
    signal,
  }) => listTopics(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTopics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTopicsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTopics>>
>;
export type ListTopicsQueryError = ErrorType<unknown>;

/**
 * @summary List feedback topics
 */

export function useListTopics<
  TData = Awaited<ReturnType<typeof listTopics>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTopicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopics>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTopicsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get topic detail
 */
export const getGetTopicUrl = (id: string, params?: GetTopicParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/topics/${id}?${stringifiedParams}`
    : `/api/topics/${id}`;
};

export const getTopic = async (
  id: string,
  params?: GetTopicParams,
  options?: RequestInit,
): Promise<TopicDetail> => {
  return customFetch<TopicDetail>(getGetTopicUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetTopicQueryKey = (id: string, params?: GetTopicParams) => {
  return [`/api/topics/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetTopicQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopic>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTopicParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopic>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopic>>> = ({
    signal,
  }) => getTopic(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTopic>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTopicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopic>>
>;
export type GetTopicQueryError = ErrorType<unknown>;

/**
 * @summary Get topic detail
 */

export function useGetTopic<
  TData = Awaited<ReturnType<typeof getTopic>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTopicParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopic>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTopicQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List tasks linked to a topic
 */
export const getListTopicTasksUrl = (id: string) => {
  return `/api/topics/${id}/tasks`;
};

export const listTopicTasks = async (
  id: string,
  options?: RequestInit,
): Promise<ListTasksResponse> => {
  return customFetch<ListTasksResponse>(getListTopicTasksUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListTopicTasksQueryKey = (id: string) => {
  return [`/api/topics/${id}/tasks`] as const;
};

export const getListTopicTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listTopicTasks>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicTasks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTopicTasksQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTopicTasks>>> = ({
    signal,
  }) => listTopicTasks(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTopicTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTopicTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTopicTasks>>
>;
export type ListTopicTasksQueryError = ErrorType<unknown>;

/**
 * @summary List tasks linked to a topic
 */

export function useListTopicTasks<
  TData = Awaited<ReturnType<typeof listTopicTasks>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicTasks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTopicTasksQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a KPI trend (mentions or critical issues) for a topic
 */
export const getGetTopicTrendUrl = (
  id: string,
  params?: GetTopicTrendParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/topics/${id}/trend?${stringifiedParams}`
    : `/api/topics/${id}/trend`;
};

export const getTopicTrend = async (
  id: string,
  params?: GetTopicTrendParams,
  options?: RequestInit,
): Promise<TopicTrendResponse> => {
  return customFetch<TopicTrendResponse>(getGetTopicTrendUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetTopicTrendQueryKey = (
  id: string,
  params?: GetTopicTrendParams,
) => {
  return [`/api/topics/${id}/trend`, ...(params ? [params] : [])] as const;
};

export const getGetTopicTrendQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopicTrend>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTopicTrendParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicTrend>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopicTrendQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopicTrend>>> = ({
    signal,
  }) => getTopicTrend(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopicTrend>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTopicTrendQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopicTrend>>
>;
export type GetTopicTrendQueryError = ErrorType<unknown>;

/**
 * @summary Get a KPI trend (mentions or critical issues) for a topic
 */

export function useGetTopicTrend<
  TData = Awaited<ReturnType<typeof getTopicTrend>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTopicTrendParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicTrend>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTopicTrendQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get AI-generated analysis of a topic mention trend
 */
export const getGetTopicTrendAnalysisUrl = (
  id: string,
  params?: GetTopicTrendAnalysisParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/topics/${id}/trend/analysis?${stringifiedParams}`
    : `/api/topics/${id}/trend/analysis`;
};

export const getTopicTrendAnalysis = async (
  id: string,
  params?: GetTopicTrendAnalysisParams,
  options?: RequestInit,
): Promise<KpiTrendAnalysisResponse> => {
  return customFetch<KpiTrendAnalysisResponse>(
    getGetTopicTrendAnalysisUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTopicTrendAnalysisQueryKey = (
  id: string,
  params?: GetTopicTrendAnalysisParams,
) => {
  return [
    `/api/topics/${id}/trend/analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTopicTrendAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopicTrendAnalysis>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTopicTrendAnalysisParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicTrendAnalysis>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopicTrendAnalysisQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopicTrendAnalysis>>
  > = ({ signal }) =>
    getTopicTrendAnalysis(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopicTrendAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTopicTrendAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopicTrendAnalysis>>
>;
export type GetTopicTrendAnalysisQueryError = ErrorType<unknown>;

/**
 * @summary Get AI-generated analysis of a topic mention trend
 */

export function useGetTopicTrendAnalysis<
  TData = Awaited<ReturnType<typeof getTopicTrendAnalysis>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTopicTrendAnalysisParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicTrendAnalysis>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTopicTrendAnalysisQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Dismiss a topic (move to archive)
 */
export const getDismissTopicUrl = (id: string) => {
  return `/api/topics/${id}/dismiss`;
};

export const dismissTopic = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDismissTopicUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDismissTopicMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissTopic>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissTopic>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["dismissTopic"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissTopic>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dismissTopic(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissTopicMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissTopic>>
>;

export type DismissTopicMutationError = ErrorType<unknown>;

/**
 * @summary Dismiss a topic (move to archive)
 */
export const useDismissTopic = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissTopic>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissTopic>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDismissTopicMutationOptions(options));
};

/**
 * @summary Restore a dismissed topic from the archive
 */
export const getRestoreTopicUrl = (id: string) => {
  return `/api/topics/${id}/restore`;
};

export const restoreTopic = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getRestoreTopicUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreTopicMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreTopic>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreTopic>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["restoreTopic"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreTopic>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return restoreTopic(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreTopicMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreTopic>>
>;

export type RestoreTopicMutationError = ErrorType<unknown>;

/**
 * @summary Restore a dismissed topic from the archive
 */
export const useRestoreTopic = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreTopic>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreTopic>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRestoreTopicMutationOptions(options));
};

/**
 * @summary Get the unified archive across reviews, topics, tasks, and actions
 */
export const getGetArchiveUrl = (params?: GetArchiveParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/archive?${stringifiedParams}`
    : `/api/archive`;
};

export const getArchive = async (
  params?: GetArchiveParams,
  options?: RequestInit,
): Promise<ArchiveResponse> => {
  return customFetch<ArchiveResponse>(getGetArchiveUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetArchiveQueryKey = (params?: GetArchiveParams) => {
  return [`/api/archive`, ...(params ? [params] : [])] as const;
};

export const getGetArchiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getArchive>>,
  TError = ErrorType<unknown>,
>(
  params?: GetArchiveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchive>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetArchiveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getArchive>>> = ({
    signal,
  }) => getArchive(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getArchive>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetArchiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getArchive>>
>;
export type GetArchiveQueryError = ErrorType<unknown>;

/**
 * @summary Get the unified archive across reviews, topics, tasks, and actions
 */

export function useGetArchive<
  TData = Awaited<ReturnType<typeof getArchive>>,
  TError = ErrorType<unknown>,
>(
  params?: GetArchiveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchive>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetArchiveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Restore multiple archived items at once
 */
export const getBulkRestoreArchiveUrl = () => {
  return `/api/archive/bulk-restore`;
};

export const bulkRestoreArchive = async (
  archiveBulkRequest: ArchiveBulkRequest,
  options?: RequestInit,
): Promise<ArchiveBulkResponse> => {
  return customFetch<ArchiveBulkResponse>(getBulkRestoreArchiveUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(archiveBulkRequest),
  });
};

export const getBulkRestoreArchiveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkRestoreArchive>>,
    TError,
    { data: BodyType<ArchiveBulkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkRestoreArchive>>,
  TError,
  { data: BodyType<ArchiveBulkRequest> },
  TContext
> => {
  const mutationKey = ["bulkRestoreArchive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkRestoreArchive>>,
    { data: BodyType<ArchiveBulkRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkRestoreArchive(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkRestoreArchiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkRestoreArchive>>
>;
export type BulkRestoreArchiveMutationBody = BodyType<ArchiveBulkRequest>;
export type BulkRestoreArchiveMutationError = ErrorType<unknown>;

/**
 * @summary Restore multiple archived items at once
 */
export const useBulkRestoreArchive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkRestoreArchive>>,
    TError,
    { data: BodyType<ArchiveBulkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkRestoreArchive>>,
  TError,
  { data: BodyType<ArchiveBulkRequest> },
  TContext
> => {
  return useMutation(getBulkRestoreArchiveMutationOptions(options));
};

/**
 * @summary Permanently delete multiple archived items at once
 */
export const getBulkDeleteArchiveUrl = () => {
  return `/api/archive/bulk-delete`;
};

export const bulkDeleteArchive = async (
  archiveBulkRequest: ArchiveBulkRequest,
  options?: RequestInit,
): Promise<ArchiveBulkResponse> => {
  return customFetch<ArchiveBulkResponse>(getBulkDeleteArchiveUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(archiveBulkRequest),
  });
};

export const getBulkDeleteArchiveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteArchive>>,
    TError,
    { data: BodyType<ArchiveBulkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteArchive>>,
  TError,
  { data: BodyType<ArchiveBulkRequest> },
  TContext
> => {
  const mutationKey = ["bulkDeleteArchive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteArchive>>,
    { data: BodyType<ArchiveBulkRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDeleteArchive(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDeleteArchiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteArchive>>
>;
export type BulkDeleteArchiveMutationBody = BodyType<ArchiveBulkRequest>;
export type BulkDeleteArchiveMutationError = ErrorType<unknown>;

/**
 * @summary Permanently delete multiple archived items at once
 */
export const useBulkDeleteArchive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteArchive>>,
    TError,
    { data: BodyType<ArchiveBulkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteArchive>>,
  TError,
  { data: BodyType<ArchiveBulkRequest> },
  TContext
> => {
  return useMutation(getBulkDeleteArchiveMutationOptions(options));
};

/**
 * @summary List recommended actions
 */
export const getListActionsUrl = () => {
  return `/api/actions`;
};

export const listActions = async (options?: RequestInit): Promise<Action[]> => {
  return customFetch<Action[]>(getListActionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListActionsQueryKey = () => {
  return [`/api/actions`] as const;
};

export const getListActionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listActions>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActions>>> = ({
    signal,
  }) => listActions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActions>>
>;
export type ListActionsQueryError = ErrorType<unknown>;

/**
 * @summary List recommended actions
 */

export function useListActions<
  TData = Awaited<ReturnType<typeof listActions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listActions>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Dismiss an action
 */
export const getDismissActionUrl = (id: string) => {
  return `/api/actions/${id}/dismiss`;
};

export const dismissAction = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDismissActionUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDismissActionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissAction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["dismissAction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissAction>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dismissAction(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissAction>>
>;

export type DismissActionMutationError = ErrorType<unknown>;

/**
 * @summary Dismiss an action
 */
export const useDismissAction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissAction>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDismissActionMutationOptions(options));
};

/**
 * @summary Restore a dismissed action from the archive
 */
export const getRestoreActionUrl = (id: string) => {
  return `/api/actions/${id}/restore`;
};

export const restoreAction = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getRestoreActionUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreActionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["restoreAction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAction>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return restoreAction(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAction>>
>;

export type RestoreActionMutationError = ErrorType<unknown>;

/**
 * @summary Restore a dismissed action from the archive
 */
export const useRestoreAction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreAction>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRestoreActionMutationOptions(options));
};

/**
 * @summary Update an action's status
 */
export const getUpdateActionStatusUrl = (id: string) => {
  return `/api/actions/${id}/status`;
};

export const updateActionStatus = async (
  id: string,
  updateActionStatusBody: UpdateActionStatusBody,
  options?: RequestInit,
): Promise<Action> => {
  return customFetch<Action>(getUpdateActionStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateActionStatusBody),
  });
};

export const getUpdateActionStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionStatus>>,
    TError,
    { id: string; data: BodyType<UpdateActionStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateActionStatus>>,
  TError,
  { id: string; data: BodyType<UpdateActionStatusBody> },
  TContext
> => {
  const mutationKey = ["updateActionStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateActionStatus>>,
    { id: string; data: BodyType<UpdateActionStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateActionStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateActionStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateActionStatus>>
>;
export type UpdateActionStatusMutationBody = BodyType<UpdateActionStatusBody>;
export type UpdateActionStatusMutationError = ErrorType<unknown>;

/**
 * @summary Update an action's status
 */
export const useUpdateActionStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionStatus>>,
    TError,
    { id: string; data: BodyType<UpdateActionStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateActionStatus>>,
  TError,
  { id: string; data: BodyType<UpdateActionStatusBody> },
  TContext
> => {
  return useMutation(getUpdateActionStatusMutationOptions(options));
};

/**
 * @summary List notifications
 */
export const getListNotificationsUrl = () => {
  return `/api/notifications`;
};

export const listNotifications = async (
  options?: RequestInit,
): Promise<NotificationsListResponse> => {
  return customFetch<NotificationsListResponse>(getListNotificationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListNotificationsQueryKey = () => {
  return [`/api/notifications`] as const;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotifications>>
  > = ({ signal }) => listNotifications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsQueryError = ErrorType<unknown>;

/**
 * @summary List notifications
 */

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotificationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark notification as read
 */
export const getMarkNotificationReadUrl = (id: string) => {
  return `/api/notifications/${id}/read`;
};

export const markNotificationRead = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getMarkNotificationReadUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getMarkNotificationReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["markNotificationRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationRead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return markNotificationRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationRead>>
>;

export type MarkNotificationReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark notification as read
 */
export const useMarkNotificationRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationRead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationRead>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getMarkNotificationReadMutationOptions(options));
};

/**
 * @summary Mark all notifications as read
 */
export const getMarkAllNotificationsReadUrl = () => {
  return `/api/notifications/read-all`;
};

export const markAllNotificationsRead = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getMarkAllNotificationsReadUrl(), {
    ...options,
    method: "POST",
  });
};

export const getMarkAllNotificationsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markAllNotificationsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    void
  > = () => {
    return markAllNotificationsRead(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllNotificationsRead>>
>;

export type MarkAllNotificationsReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark all notifications as read
 */
export const useMarkAllNotificationsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAllNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getMarkAllNotificationsReadMutationOptions(options));
};

/**
 * @summary List data sources
 */
export const getListDataSourcesUrl = () => {
  return `/api/data-sources`;
};

export const listDataSources = async (
  options?: RequestInit,
): Promise<DataSource[]> => {
  return customFetch<DataSource[]>(getListDataSourcesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDataSourcesQueryKey = () => {
  return [`/api/data-sources`] as const;
};

export const getListDataSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDataSources>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSources>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDataSourcesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataSources>>> = ({
    signal,
  }) => listDataSources({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDataSources>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDataSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDataSources>>
>;
export type ListDataSourcesQueryError = ErrorType<unknown>;

/**
 * @summary List data sources
 */

export function useListDataSources<
  TData = Awaited<ReturnType<typeof listDataSources>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSources>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDataSourcesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload a data file
 */
export const getUploadDataSourceUrl = () => {
  return `/api/data-sources/upload`;
};

export const uploadDataSource = async (
  uploadDataSourceBody: UploadDataSourceBody,
  options?: RequestInit,
): Promise<DataSource> => {
  return customFetch<DataSource>(getUploadDataSourceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadDataSourceBody),
  });
};

export const getUploadDataSourceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadDataSource>>,
    TError,
    { data: BodyType<UploadDataSourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadDataSource>>,
  TError,
  { data: BodyType<UploadDataSourceBody> },
  TContext
> => {
  const mutationKey = ["uploadDataSource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadDataSource>>,
    { data: BodyType<UploadDataSourceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadDataSource(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadDataSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadDataSource>>
>;
export type UploadDataSourceMutationBody = BodyType<UploadDataSourceBody>;
export type UploadDataSourceMutationError = ErrorType<unknown>;

/**
 * @summary Upload a data file
 */
export const useUploadDataSource = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadDataSource>>,
    TError,
    { data: BodyType<UploadDataSourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadDataSource>>,
  TError,
  { data: BodyType<UploadDataSourceBody> },
  TContext
> => {
  return useMutation(getUploadDataSourceMutationOptions(options));
};

/**
 * Removes a data source. By default, the rows it produced (reviews) are
left active in the org. Pass `archive=true` to soft-archive those rows
so they're hidden from dashboards but restorable from the Archive page.

 * @summary Delete a data source
 */
export const getDeleteDataSourceUrl = (
  id: string,
  params?: DeleteDataSourceParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/data-sources/${id}?${stringifiedParams}`
    : `/api/data-sources/${id}`;
};

export const deleteDataSource = async (
  id: string,
  params?: DeleteDataSourceParams,
  options?: RequestInit,
): Promise<DeleteDataSourceResponse> => {
  return customFetch<DeleteDataSourceResponse>(
    getDeleteDataSourceUrl(id, params),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteDataSourceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDataSource>>,
    TError,
    { id: string; params?: DeleteDataSourceParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDataSource>>,
  TError,
  { id: string; params?: DeleteDataSourceParams },
  TContext
> => {
  const mutationKey = ["deleteDataSource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDataSource>>,
    { id: string; params?: DeleteDataSourceParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return deleteDataSource(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDataSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDataSource>>
>;

export type DeleteDataSourceMutationError = ErrorType<unknown>;

/**
 * @summary Delete a data source
 */
export const useDeleteDataSource = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDataSource>>,
    TError,
    { id: string; params?: DeleteDataSourceParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDataSource>>,
  TError,
  { id: string; params?: DeleteDataSourceParams },
  TContext
> => {
  return useMutation(getDeleteDataSourceMutationOptions(options));
};

/**
 * @summary List ingestion run history for a data source
 */
export const getListDataSourceRunsUrl = (id: string) => {
  return `/api/data-sources/${id}/runs`;
};

export const listDataSourceRuns = async (
  id: string,
  options?: RequestInit,
): Promise<DataSourceRun[]> => {
  return customFetch<DataSourceRun[]>(getListDataSourceRunsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListDataSourceRunsQueryKey = (id: string) => {
  return [`/api/data-sources/${id}/runs`] as const;
};

export const getListDataSourceRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDataSourceRuns>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSourceRuns>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDataSourceRunsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDataSourceRuns>>
  > = ({ signal }) => listDataSourceRuns(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDataSourceRuns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDataSourceRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDataSourceRuns>>
>;
export type ListDataSourceRunsQueryError = ErrorType<unknown>;

/**
 * @summary List ingestion run history for a data source
 */

export function useListDataSourceRuns<
  TData = Awaited<ReturnType<typeof listDataSourceRuns>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSourceRuns>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDataSourceRunsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Idempotent per-id bulk action. A failure on one id never aborts the batch — every id gets its own entry in `results`.
 * @summary Bulk archive or re-scan data sources (admin)
 */
export const getBulkDataSourceActionUrl = () => {
  return `/api/data-sources/bulk`;
};

export const bulkDataSourceAction = async (
  bulkActionRequest: BulkActionRequest,
  options?: RequestInit,
): Promise<BulkActionResponse> => {
  return customFetch<BulkActionResponse>(getBulkDataSourceActionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkActionRequest),
  });
};

export const getBulkDataSourceActionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDataSourceAction>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDataSourceAction>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  const mutationKey = ["bulkDataSourceAction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDataSourceAction>>,
    { data: BodyType<BulkActionRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDataSourceAction(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDataSourceActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDataSourceAction>>
>;
export type BulkDataSourceActionMutationBody = BodyType<BulkActionRequest>;
export type BulkDataSourceActionMutationError = ErrorType<unknown>;

/**
 * @summary Bulk archive or re-scan data sources (admin)
 */
export const useBulkDataSourceAction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDataSourceAction>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkDataSourceAction>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  return useMutation(getBulkDataSourceActionMutationOptions(options));
};

/**
 * @summary Re-map columns on a CSV data source and re-ingest
 */
export const getRemapDataSourceUrl = (id: string) => {
  return `/api/data-sources/${id}/remap`;
};

export const remapDataSource = async (
  id: string,
  remapDataSourceBody: RemapDataSourceBody,
  options?: RequestInit,
): Promise<DataSource> => {
  return customFetch<DataSource>(getRemapDataSourceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(remapDataSourceBody),
  });
};

export const getRemapDataSourceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof remapDataSource>>,
    TError,
    { id: string; data: BodyType<RemapDataSourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof remapDataSource>>,
  TError,
  { id: string; data: BodyType<RemapDataSourceBody> },
  TContext
> => {
  const mutationKey = ["remapDataSource"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof remapDataSource>>,
    { id: string; data: BodyType<RemapDataSourceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return remapDataSource(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemapDataSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof remapDataSource>>
>;
export type RemapDataSourceMutationBody = BodyType<RemapDataSourceBody>;
export type RemapDataSourceMutationError = ErrorType<unknown>;

/**
 * @summary Re-map columns on a CSV data source and re-ingest
 */
export const useRemapDataSource = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof remapDataSource>>,
    TError,
    { id: string; data: BodyType<RemapDataSourceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof remapDataSource>>,
  TError,
  { id: string; data: BodyType<RemapDataSourceBody> },
  TContext
> => {
  return useMutation(getRemapDataSourceMutationOptions(options));
};

/**
 * @summary List analysis history
 */
export const getListHistoryUrl = (params?: ListHistoryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/history?${stringifiedParams}`
    : `/api/history`;
};

export const listHistory = async (
  params?: ListHistoryParams,
  options?: RequestInit,
): Promise<HistoryEntry[]> => {
  return customFetch<HistoryEntry[]>(getListHistoryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListHistoryQueryKey = (params?: ListHistoryParams) => {
  return [`/api/history`, ...(params ? [params] : [])] as const;
};

export const getListHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHistory>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHistory>>> = ({
    signal,
  }) => listHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHistory>>
>;
export type ListHistoryQueryError = ErrorType<unknown>;

/**
 * @summary List analysis history
 */

export function useListHistory<
  TData = Awaited<ReturnType<typeof listHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: ListHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHistory>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get details for a single history entry
 */
export const getGetHistoryDetailUrl = (id: string) => {
  return `/api/history/${id}`;
};

export const getHistoryDetail = async (
  id: string,
  options?: RequestInit,
): Promise<HistoryDetail> => {
  return customFetch<HistoryDetail>(getGetHistoryDetailUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetHistoryDetailQueryKey = (id: string) => {
  return [`/api/history/${id}`] as const;
};

export const getGetHistoryDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getHistoryDetail>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistoryDetail>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHistoryDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHistoryDetail>>
  > = ({ signal }) => getHistoryDetail(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHistoryDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHistoryDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHistoryDetail>>
>;
export type GetHistoryDetailQueryError = ErrorType<void>;

/**
 * @summary Get details for a single history entry
 */

export function useGetHistoryDetail<
  TData = Awaited<ReturnType<typeof getHistoryDetail>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistoryDetail>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHistoryDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get user/org settings
 */
export const getGetSettingsUrl = () => {
  return `/api/settings`;
};

export const getSettings = async (options?: RequestInit): Promise<Settings> => {
  return customFetch<Settings>(getGetSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSettingsQueryKey = () => {
  return [`/api/settings`] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({
    signal,
  }) => getSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettings>>
>;
export type GetSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get user/org settings
 */

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update settings
 */
export const getUpdateSettingsUrl = () => {
  return `/api/settings`;
};

export const updateSettings = async (
  updateSettingsBody: UpdateSettingsBody,
  options?: RequestInit,
): Promise<Settings> => {
  return customFetch<Settings>(getUpdateSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSettingsBody),
  });
};

export const getUpdateSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: BodyType<UpdateSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: BodyType<UpdateSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSettings>>,
    { data: BodyType<UpdateSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSettings>>
>;
export type UpdateSettingsMutationBody = BodyType<UpdateSettingsBody>;
export type UpdateSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update settings
 */
export const useUpdateSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: BodyType<UpdateSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: BodyType<UpdateSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateSettingsMutationOptions(options));
};

/**
 * @summary Update reporting cadence
 */
export const getUpdateReportingCadenceUrl = () => {
  return `/api/settings/reporting-cadence`;
};

export const updateReportingCadence = async (
  updateReportingCadenceBody: UpdateReportingCadenceBody,
  options?: RequestInit,
): Promise<UpdateReportingCadence200> => {
  return customFetch<UpdateReportingCadence200>(
    getUpdateReportingCadenceUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateReportingCadenceBody),
    },
  );
};

export const getUpdateReportingCadenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReportingCadence>>,
    TError,
    { data: BodyType<UpdateReportingCadenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReportingCadence>>,
  TError,
  { data: BodyType<UpdateReportingCadenceBody> },
  TContext
> => {
  const mutationKey = ["updateReportingCadence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReportingCadence>>,
    { data: BodyType<UpdateReportingCadenceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateReportingCadence(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReportingCadenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReportingCadence>>
>;
export type UpdateReportingCadenceMutationBody =
  BodyType<UpdateReportingCadenceBody>;
export type UpdateReportingCadenceMutationError = ErrorType<unknown>;

/**
 * @summary Update reporting cadence
 */
export const useUpdateReportingCadence = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReportingCadence>>,
    TError,
    { data: BodyType<UpdateReportingCadenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReportingCadence>>,
  TError,
  { data: BodyType<UpdateReportingCadenceBody> },
  TContext
> => {
  return useMutation(getUpdateReportingCadenceMutationOptions(options));
};

/**
 * @summary List available integrations
 */
export const getListIntegrationsUrl = () => {
  return `/api/integrations`;
};

export const listIntegrations = async (
  options?: RequestInit,
): Promise<Integration[]> => {
  return customFetch<Integration[]>(getListIntegrationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListIntegrationsQueryKey = () => {
  return [`/api/integrations`] as const;
};

export const getListIntegrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listIntegrations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListIntegrationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listIntegrations>>
  > = ({ signal }) => listIntegrations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listIntegrations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListIntegrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listIntegrations>>
>;
export type ListIntegrationsQueryError = ErrorType<unknown>;

/**
 * @summary List available integrations
 */

export function useListIntegrations<
  TData = Awaited<ReturnType<typeof listIntegrations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListIntegrationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Connect an integration
 */
export const getConnectIntegrationUrl = (id: string) => {
  return `/api/integrations/${id}/connect`;
};

export const connectIntegration = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getConnectIntegrationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getConnectIntegrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectIntegration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectIntegration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["connectIntegration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectIntegration>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return connectIntegration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectIntegration>>
>;

export type ConnectIntegrationMutationError = ErrorType<unknown>;

/**
 * @summary Connect an integration
 */
export const useConnectIntegration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectIntegration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof connectIntegration>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getConnectIntegrationMutationOptions(options));
};

/**
 * @summary Disconnect an integration
 */
export const getDisconnectIntegrationUrl = (id: string) => {
  return `/api/integrations/${id}/disconnect`;
};

export const disconnectIntegration = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDisconnectIntegrationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectIntegrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectIntegration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectIntegration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["disconnectIntegration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectIntegration>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return disconnectIntegration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectIntegration>>
>;

export type DisconnectIntegrationMutationError = ErrorType<unknown>;

/**
 * @summary Disconnect an integration
 */
export const useDisconnectIntegration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectIntegration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectIntegration>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDisconnectIntegrationMutationOptions(options));
};

/**
 * @summary Begin Facebook OAuth flow (redirect to Facebook login)
 */
export const getStartFacebookOAuthUrl = () => {
  return `/api/facebook/oauth/start`;
};

export const startFacebookOAuth = async (
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getStartFacebookOAuthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getStartFacebookOAuthQueryKey = () => {
  return [`/api/facebook/oauth/start`] as const;
};

export const getStartFacebookOAuthQueryOptions = <
  TData = Awaited<ReturnType<typeof startFacebookOAuth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof startFacebookOAuth>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStartFacebookOAuthQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof startFacebookOAuth>>
  > = ({ signal }) => startFacebookOAuth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof startFacebookOAuth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StartFacebookOAuthQueryResult = NonNullable<
  Awaited<ReturnType<typeof startFacebookOAuth>>
>;
export type StartFacebookOAuthQueryError = ErrorType<void>;

/**
 * @summary Begin Facebook OAuth flow (redirect to Facebook login)
 */

export function useStartFacebookOAuth<
  TData = Awaited<ReturnType<typeof startFacebookOAuth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof startFacebookOAuth>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getStartFacebookOAuthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Facebook OAuth callback — exchanges code for token and closes popup
 */
export const getFacebookOAuthCallbackUrl = (
  params?: FacebookOAuthCallbackParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/facebook/oauth/callback?${stringifiedParams}`
    : `/api/facebook/oauth/callback`;
};

export const facebookOAuthCallback = async (
  params?: FacebookOAuthCallbackParams,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getFacebookOAuthCallbackUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getFacebookOAuthCallbackQueryKey = (
  params?: FacebookOAuthCallbackParams,
) => {
  return [`/api/facebook/oauth/callback`, ...(params ? [params] : [])] as const;
};

export const getFacebookOAuthCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof facebookOAuthCallback>>,
  TError = ErrorType<unknown>,
>(
  params?: FacebookOAuthCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof facebookOAuthCallback>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFacebookOAuthCallbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof facebookOAuthCallback>>
  > = ({ signal }) =>
    facebookOAuthCallback(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof facebookOAuthCallback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FacebookOAuthCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof facebookOAuthCallback>>
>;
export type FacebookOAuthCallbackQueryError = ErrorType<unknown>;

/**
 * @summary Facebook OAuth callback — exchanges code for token and closes popup
 */

export function useFacebookOAuthCallback<
  TData = Awaited<ReturnType<typeof facebookOAuthCallback>>,
  TError = ErrorType<unknown>,
>(
  params?: FacebookOAuthCallbackParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof facebookOAuthCallback>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFacebookOAuthCallbackQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get Facebook OAuth connection status
 */
export const getGetFacebookOAuthStatusUrl = () => {
  return `/api/facebook/oauth/status`;
};

export const getFacebookOAuthStatus = async (
  options?: RequestInit,
): Promise<FacebookOAuthStatus> => {
  return customFetch<FacebookOAuthStatus>(getGetFacebookOAuthStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetFacebookOAuthStatusQueryKey = () => {
  return [`/api/facebook/oauth/status`] as const;
};

export const getGetFacebookOAuthStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getFacebookOAuthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacebookOAuthStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFacebookOAuthStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFacebookOAuthStatus>>
  > = ({ signal }) => getFacebookOAuthStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFacebookOAuthStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFacebookOAuthStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFacebookOAuthStatus>>
>;
export type GetFacebookOAuthStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get Facebook OAuth connection status
 */

export function useGetFacebookOAuthStatus<
  TData = Awaited<ReturnType<typeof getFacebookOAuthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacebookOAuthStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFacebookOAuthStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Disconnect Facebook Ads integration
 */
export const getDisconnectFacebookOAuthUrl = () => {
  return `/api/facebook/oauth/disconnect`;
};

export const disconnectFacebookOAuth = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDisconnectFacebookOAuthUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectFacebookOAuthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectFacebookOAuth>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectFacebookOAuth>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectFacebookOAuth"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectFacebookOAuth>>,
    void
  > = () => {
    return disconnectFacebookOAuth(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectFacebookOAuthMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectFacebookOAuth>>
>;

export type DisconnectFacebookOAuthMutationError = ErrorType<unknown>;

/**
 * @summary Disconnect Facebook Ads integration
 */
export const useDisconnectFacebookOAuth = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectFacebookOAuth>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectFacebookOAuth>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDisconnectFacebookOAuthMutationOptions(options));
};

/**
 * @summary Trigger a manual Facebook feedback sync
 */
export const getSyncFacebookFeedbackUrl = () => {
  return `/api/facebook/sync-feedback`;
};

export const syncFacebookFeedback = async (
  options?: RequestInit,
): Promise<FacebookSyncResult> => {
  return customFetch<FacebookSyncResult>(getSyncFacebookFeedbackUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSyncFacebookFeedbackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncFacebookFeedback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncFacebookFeedback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncFacebookFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncFacebookFeedback>>,
    void
  > = () => {
    return syncFacebookFeedback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncFacebookFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncFacebookFeedback>>
>;

export type SyncFacebookFeedbackMutationError = ErrorType<unknown>;

/**
 * @summary Trigger a manual Facebook feedback sync
 */
export const useSyncFacebookFeedback = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncFacebookFeedback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncFacebookFeedback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSyncFacebookFeedbackMutationOptions(options));
};

/**
 * @summary Get Facebook sync status, last sync time, and token health
 */
export const getGetFacebookSyncStatusUrl = () => {
  return `/api/facebook/sync-status`;
};

export const getFacebookSyncStatus = async (
  options?: RequestInit,
): Promise<FacebookSyncStatusResponse> => {
  return customFetch<FacebookSyncStatusResponse>(
    getGetFacebookSyncStatusUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetFacebookSyncStatusQueryKey = () => {
  return [`/api/facebook/sync-status`] as const;
};

export const getGetFacebookSyncStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getFacebookSyncStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacebookSyncStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFacebookSyncStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFacebookSyncStatus>>
  > = ({ signal }) => getFacebookSyncStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFacebookSyncStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFacebookSyncStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFacebookSyncStatus>>
>;
export type GetFacebookSyncStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get Facebook sync status, last sync time, and token health
 */

export function useGetFacebookSyncStatus<
  TData = Awaited<ReturnType<typeof getFacebookSyncStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacebookSyncStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFacebookSyncStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get Google OAuth connection status including pendingSetup flag
 */
export const getGetGoogleOAuthStatusUrl = () => {
  return `/api/google/oauth/status`;
};

export const getGoogleOAuthStatus = async (
  options?: RequestInit,
): Promise<GoogleOAuthStatusResponse> => {
  return customFetch<GoogleOAuthStatusResponse>(getGetGoogleOAuthStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGoogleOAuthStatusQueryKey = () => {
  return [`/api/google/oauth/status`] as const;
};

export const getGetGoogleOAuthStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoogleOAuthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleOAuthStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGoogleOAuthStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoogleOAuthStatus>>
  > = ({ signal }) => getGoogleOAuthStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoogleOAuthStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoogleOAuthStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoogleOAuthStatus>>
>;
export type GetGoogleOAuthStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get Google OAuth connection status including pendingSetup flag
 */

export function useGetGoogleOAuthStatus<
  TData = Awaited<ReturnType<typeof getGoogleOAuthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleOAuthStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGoogleOAuthStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List available Google Business locations after OAuth
 */
export const getGetGoogleLocationsUrl = () => {
  return `/api/google/locations`;
};

export const getGoogleLocations = async (
  options?: RequestInit,
): Promise<GoogleLocationsResponse> => {
  return customFetch<GoogleLocationsResponse>(getGetGoogleLocationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGoogleLocationsQueryKey = () => {
  return [`/api/google/locations`] as const;
};

export const getGetGoogleLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoogleLocations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleLocations>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGoogleLocationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoogleLocations>>
  > = ({ signal }) => getGoogleLocations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoogleLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoogleLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoogleLocations>>
>;
export type GetGoogleLocationsQueryError = ErrorType<unknown>;

/**
 * @summary List available Google Business locations after OAuth
 */

export function useGetGoogleLocations<
  TData = Awaited<ReturnType<typeof getGoogleLocations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleLocations>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGoogleLocationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Select which Google Business locations to sync reviews from
 */
export const getSelectGoogleLocationsUrl = () => {
  return `/api/google/locations/select`;
};

export const selectGoogleLocations = async (
  googleSelectLocationsBody: GoogleSelectLocationsBody,
  options?: RequestInit,
): Promise<GoogleSelectLocationsResponse> => {
  return customFetch<GoogleSelectLocationsResponse>(
    getSelectGoogleLocationsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(googleSelectLocationsBody),
    },
  );
};

export const getSelectGoogleLocationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectGoogleLocations>>,
    TError,
    { data: BodyType<GoogleSelectLocationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectGoogleLocations>>,
  TError,
  { data: BodyType<GoogleSelectLocationsBody> },
  TContext
> => {
  const mutationKey = ["selectGoogleLocations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectGoogleLocations>>,
    { data: BodyType<GoogleSelectLocationsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return selectGoogleLocations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectGoogleLocationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof selectGoogleLocations>>
>;
export type SelectGoogleLocationsMutationBody =
  BodyType<GoogleSelectLocationsBody>;
export type SelectGoogleLocationsMutationError = ErrorType<unknown>;

/**
 * @summary Select which Google Business locations to sync reviews from
 */
export const useSelectGoogleLocations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectGoogleLocations>>,
    TError,
    { data: BodyType<GoogleSelectLocationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectGoogleLocations>>,
  TError,
  { data: BodyType<GoogleSelectLocationsBody> },
  TContext
> => {
  return useMutation(getSelectGoogleLocationsMutationOptions(options));
};

/**
 * @summary Disconnect Google Business Profile integration
 */
export const getDisconnectGoogleOAuthUrl = () => {
  return `/api/google/oauth/disconnect`;
};

export const disconnectGoogleOAuth = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDisconnectGoogleOAuthUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectGoogleOAuthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGoogleOAuth>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectGoogleOAuth>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectGoogleOAuth"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectGoogleOAuth>>,
    void
  > = () => {
    return disconnectGoogleOAuth(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectGoogleOAuthMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectGoogleOAuth>>
>;

export type DisconnectGoogleOAuthMutationError = ErrorType<unknown>;

/**
 * @summary Disconnect Google Business Profile integration
 */
export const useDisconnectGoogleOAuth = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGoogleOAuth>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectGoogleOAuth>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDisconnectGoogleOAuthMutationOptions(options));
};

/**
 * @summary Trigger a manual Google Reviews sync
 */
export const getSyncGoogleReviewsUrl = () => {
  return `/api/google/sync-reviews`;
};

export const syncGoogleReviews = async (
  options?: RequestInit,
): Promise<GoogleSyncResult> => {
  return customFetch<GoogleSyncResult>(getSyncGoogleReviewsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSyncGoogleReviewsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncGoogleReviews>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncGoogleReviews>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncGoogleReviews"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncGoogleReviews>>,
    void
  > = () => {
    return syncGoogleReviews(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncGoogleReviewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncGoogleReviews>>
>;

export type SyncGoogleReviewsMutationError = ErrorType<unknown>;

/**
 * @summary Trigger a manual Google Reviews sync
 */
export const useSyncGoogleReviews = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncGoogleReviews>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncGoogleReviews>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSyncGoogleReviewsMutationOptions(options));
};

/**
 * @summary Get Google Reviews sync status and location count
 */
export const getGetGoogleSyncStatusUrl = () => {
  return `/api/google/sync-status`;
};

export const getGoogleSyncStatus = async (
  options?: RequestInit,
): Promise<GoogleSyncStatusResponse> => {
  return customFetch<GoogleSyncStatusResponse>(getGetGoogleSyncStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGoogleSyncStatusQueryKey = () => {
  return [`/api/google/sync-status`] as const;
};

export const getGetGoogleSyncStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoogleSyncStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleSyncStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGoogleSyncStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoogleSyncStatus>>
  > = ({ signal }) => getGoogleSyncStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoogleSyncStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoogleSyncStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoogleSyncStatus>>
>;
export type GetGoogleSyncStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get Google Reviews sync status and location count
 */

export function useGetGoogleSyncStatus<
  TData = Awaited<ReturnType<typeof getGoogleSyncStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleSyncStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGoogleSyncStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Count Google reviews still missing a source URL
 */
export const getGetGoogleMissingSourceUrlsCountUrl = () => {
  return `/api/google/missing-source-urls-count`;
};

export const getGoogleMissingSourceUrlsCount = async (
  options?: RequestInit,
): Promise<GoogleMissingSourceUrlsCountResponse> => {
  return customFetch<GoogleMissingSourceUrlsCountResponse>(
    getGetGoogleMissingSourceUrlsCountUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetGoogleMissingSourceUrlsCountQueryKey = () => {
  return [`/api/google/missing-source-urls-count`] as const;
};

export const getGetGoogleMissingSourceUrlsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoogleMissingSourceUrlsCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleMissingSourceUrlsCount>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGoogleMissingSourceUrlsCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoogleMissingSourceUrlsCount>>
  > = ({ signal }) =>
    getGoogleMissingSourceUrlsCount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoogleMissingSourceUrlsCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGoogleMissingSourceUrlsCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoogleMissingSourceUrlsCount>>
>;
export type GetGoogleMissingSourceUrlsCountQueryError = ErrorType<unknown>;

/**
 * @summary Count Google reviews still missing a source URL
 */

export function useGetGoogleMissingSourceUrlsCount<
  TData = Awaited<ReturnType<typeof getGoogleMissingSourceUrlsCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleMissingSourceUrlsCount>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGoogleMissingSourceUrlsCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Backfill missing Google review source URLs from Maps URIs
 */
export const getBackfillGoogleSourceUrlsUrl = () => {
  return `/api/google/backfill-source-urls`;
};

export const backfillGoogleSourceUrls = async (
  options?: RequestInit,
): Promise<GoogleBackfillSourceUrlsResponse> => {
  return customFetch<GoogleBackfillSourceUrlsResponse>(
    getBackfillGoogleSourceUrlsUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getBackfillGoogleSourceUrlsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillGoogleSourceUrls>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backfillGoogleSourceUrls>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["backfillGoogleSourceUrls"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backfillGoogleSourceUrls>>,
    void
  > = () => {
    return backfillGoogleSourceUrls(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackfillGoogleSourceUrlsMutationResult = NonNullable<
  Awaited<ReturnType<typeof backfillGoogleSourceUrls>>
>;

export type BackfillGoogleSourceUrlsMutationError = ErrorType<unknown>;

/**
 * @summary Backfill missing Google review source URLs from Maps URIs
 */
export const useBackfillGoogleSourceUrls = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillGoogleSourceUrls>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof backfillGoogleSourceUrls>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getBackfillGoogleSourceUrlsMutationOptions(options));
};

/**
 * @summary Get daily time-series joining campaign spend with feedback volume and sentiment
 */
export const getGetFacebookCampaignCorrelationUrl = (
  params?: GetFacebookCampaignCorrelationParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/facebook/campaigns/correlation?${stringifiedParams}`
    : `/api/facebook/campaigns/correlation`;
};

export const getFacebookCampaignCorrelation = async (
  params?: GetFacebookCampaignCorrelationParams,
  options?: RequestInit,
): Promise<FacebookCorrelationResponse> => {
  return customFetch<FacebookCorrelationResponse>(
    getGetFacebookCampaignCorrelationUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetFacebookCampaignCorrelationQueryKey = (
  params?: GetFacebookCampaignCorrelationParams,
) => {
  return [
    `/api/facebook/campaigns/correlation`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFacebookCampaignCorrelationQueryOptions = <
  TData = Awaited<ReturnType<typeof getFacebookCampaignCorrelation>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFacebookCampaignCorrelationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacebookCampaignCorrelation>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFacebookCampaignCorrelationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFacebookCampaignCorrelation>>
  > = ({ signal }) =>
    getFacebookCampaignCorrelation(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFacebookCampaignCorrelation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFacebookCampaignCorrelationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFacebookCampaignCorrelation>>
>;
export type GetFacebookCampaignCorrelationQueryError = ErrorType<unknown>;

/**
 * @summary Get daily time-series joining campaign spend with feedback volume and sentiment
 */

export function useGetFacebookCampaignCorrelation<
  TData = Awaited<ReturnType<typeof getFacebookCampaignCorrelation>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFacebookCampaignCorrelationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacebookCampaignCorrelation>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFacebookCampaignCorrelationQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all Facebook ad campaigns with ad sets and ads
 */
export const getListFacebookAdCampaignsUrl = () => {
  return `/api/facebook/ads/campaigns`;
};

export const listFacebookAdCampaigns = async (
  options?: RequestInit,
): Promise<FacebookAdCampaignsResponse> => {
  return customFetch<FacebookAdCampaignsResponse>(
    getListFacebookAdCampaignsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListFacebookAdCampaignsQueryKey = () => {
  return [`/api/facebook/ads/campaigns`] as const;
};

export const getListFacebookAdCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFacebookAdCampaigns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFacebookAdCampaigns>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFacebookAdCampaignsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFacebookAdCampaigns>>
  > = ({ signal }) => listFacebookAdCampaigns({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFacebookAdCampaigns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFacebookAdCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFacebookAdCampaigns>>
>;
export type ListFacebookAdCampaignsQueryError = ErrorType<unknown>;

/**
 * @summary List all Facebook ad campaigns with ad sets and ads
 */

export function useListFacebookAdCampaigns<
  TData = Awaited<ReturnType<typeof listFacebookAdCampaigns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFacebookAdCampaigns>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFacebookAdCampaignsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new Facebook campaign with optional ad set and ad
 */
export const getCreateFacebookAdCampaignUrl = () => {
  return `/api/facebook/ads/campaigns`;
};

export const createFacebookAdCampaign = async (
  createFacebookCampaignBody: CreateFacebookCampaignBody,
  options?: RequestInit,
): Promise<CreateFacebookCampaignResponse> => {
  return customFetch<CreateFacebookCampaignResponse>(
    getCreateFacebookAdCampaignUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createFacebookCampaignBody),
    },
  );
};

export const getCreateFacebookAdCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFacebookAdCampaign>>,
    TError,
    { data: BodyType<CreateFacebookCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFacebookAdCampaign>>,
  TError,
  { data: BodyType<CreateFacebookCampaignBody> },
  TContext
> => {
  const mutationKey = ["createFacebookAdCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFacebookAdCampaign>>,
    { data: BodyType<CreateFacebookCampaignBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFacebookAdCampaign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFacebookAdCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFacebookAdCampaign>>
>;
export type CreateFacebookAdCampaignMutationBody =
  BodyType<CreateFacebookCampaignBody>;
export type CreateFacebookAdCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Create a new Facebook campaign with optional ad set and ad
 */
export const useCreateFacebookAdCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFacebookAdCampaign>>,
    TError,
    { data: BodyType<CreateFacebookCampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFacebookAdCampaign>>,
  TError,
  { data: BodyType<CreateFacebookCampaignBody> },
  TContext
> => {
  return useMutation(getCreateFacebookAdCampaignMutationOptions(options));
};

/**
 * @summary Pause, activate, or archive a campaign
 */
export const getUpdateFacebookCampaignStatusUrl = (campaignId: string) => {
  return `/api/facebook/ads/campaigns/${campaignId}/status`;
};

export const updateFacebookCampaignStatus = async (
  campaignId: string,
  updateCampaignStatusBody: UpdateCampaignStatusBody,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(
    getUpdateFacebookCampaignStatusUrl(campaignId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateCampaignStatusBody),
    },
  );
};

export const getUpdateFacebookCampaignStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFacebookCampaignStatus>>,
    TError,
    { campaignId: string; data: BodyType<UpdateCampaignStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFacebookCampaignStatus>>,
  TError,
  { campaignId: string; data: BodyType<UpdateCampaignStatusBody> },
  TContext
> => {
  const mutationKey = ["updateFacebookCampaignStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFacebookCampaignStatus>>,
    { campaignId: string; data: BodyType<UpdateCampaignStatusBody> }
  > = (props) => {
    const { campaignId, data } = props ?? {};

    return updateFacebookCampaignStatus(campaignId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFacebookCampaignStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFacebookCampaignStatus>>
>;
export type UpdateFacebookCampaignStatusMutationBody =
  BodyType<UpdateCampaignStatusBody>;
export type UpdateFacebookCampaignStatusMutationError = ErrorType<unknown>;

/**
 * @summary Pause, activate, or archive a campaign
 */
export const useUpdateFacebookCampaignStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFacebookCampaignStatus>>,
    TError,
    { campaignId: string; data: BodyType<UpdateCampaignStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFacebookCampaignStatus>>,
  TError,
  { campaignId: string; data: BodyType<UpdateCampaignStatusBody> },
  TContext
> => {
  return useMutation(getUpdateFacebookCampaignStatusMutationOptions(options));
};

/**
 * @summary List Custom Audiences in the connected Ad Account
 */
export const getListFacebookAudiencesUrl = () => {
  return `/api/facebook/audiences`;
};

export const listFacebookAudiences = async (
  options?: RequestInit,
): Promise<FacebookAudiencesResponse> => {
  return customFetch<FacebookAudiencesResponse>(getListFacebookAudiencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListFacebookAudiencesQueryKey = () => {
  return [`/api/facebook/audiences`] as const;
};

export const getListFacebookAudiencesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFacebookAudiences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFacebookAudiences>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFacebookAudiencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFacebookAudiences>>
  > = ({ signal }) => listFacebookAudiences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFacebookAudiences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFacebookAudiencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFacebookAudiences>>
>;
export type ListFacebookAudiencesQueryError = ErrorType<unknown>;

/**
 * @summary List Custom Audiences in the connected Ad Account
 */

export function useListFacebookAudiences<
  TData = Awaited<ReturnType<typeof listFacebookAudiences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFacebookAudiences>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFacebookAudiencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a Custom Audience from a feedback topic + sentiment segment
 */
export const getCreateFacebookAudienceFromSegmentUrl = () => {
  return `/api/facebook/audiences/from-segment`;
};

export const createFacebookAudienceFromSegment = async (
  createAudienceFromSegmentBody: CreateAudienceFromSegmentBody,
  options?: RequestInit,
): Promise<CreateAudienceFromSegmentResponse> => {
  return customFetch<CreateAudienceFromSegmentResponse>(
    getCreateFacebookAudienceFromSegmentUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createAudienceFromSegmentBody),
    },
  );
};

export const getCreateFacebookAudienceFromSegmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFacebookAudienceFromSegment>>,
    TError,
    { data: BodyType<CreateAudienceFromSegmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFacebookAudienceFromSegment>>,
  TError,
  { data: BodyType<CreateAudienceFromSegmentBody> },
  TContext
> => {
  const mutationKey = ["createFacebookAudienceFromSegment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFacebookAudienceFromSegment>>,
    { data: BodyType<CreateAudienceFromSegmentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFacebookAudienceFromSegment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFacebookAudienceFromSegmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFacebookAudienceFromSegment>>
>;
export type CreateFacebookAudienceFromSegmentMutationBody =
  BodyType<CreateAudienceFromSegmentBody>;
export type CreateFacebookAudienceFromSegmentMutationError = ErrorType<unknown>;

/**
 * @summary Create a Custom Audience from a feedback topic + sentiment segment
 */
export const useCreateFacebookAudienceFromSegment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFacebookAudienceFromSegment>>,
    TError,
    { data: BodyType<CreateAudienceFromSegmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFacebookAudienceFromSegment>>,
  TError,
  { data: BodyType<CreateAudienceFromSegmentBody> },
  TContext
> => {
  return useMutation(
    getCreateFacebookAudienceFromSegmentMutationOptions(options),
  );
};

/**
 * @summary Get webhook configuration
 */
export const getGetZapierConfigUrl = () => {
  return `/api/zapier/config`;
};

export const getZapierConfig = async (
  options?: RequestInit,
): Promise<ZapierConfigResponse> => {
  return customFetch<ZapierConfigResponse>(getGetZapierConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetZapierConfigQueryKey = () => {
  return [`/api/zapier/config`] as const;
};

export const getGetZapierConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getZapierConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZapierConfig>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetZapierConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getZapierConfig>>> = ({
    signal,
  }) => getZapierConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getZapierConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetZapierConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getZapierConfig>>
>;
export type GetZapierConfigQueryError = ErrorType<unknown>;

/**
 * @summary Get webhook configuration
 */

export function useGetZapierConfig<
  TData = Awaited<ReturnType<typeof getZapierConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZapierConfig>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetZapierConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save webhook configuration
 */
export const getUpdateZapierConfigUrl = () => {
  return `/api/zapier/config`;
};

export const updateZapierConfig = async (
  updateZapierConfigBody: UpdateZapierConfigBody,
  options?: RequestInit,
): Promise<ZapierConfigSaveResponse> => {
  return customFetch<ZapierConfigSaveResponse>(getUpdateZapierConfigUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateZapierConfigBody),
  });
};

export const getUpdateZapierConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateZapierConfig>>,
    TError,
    { data: BodyType<UpdateZapierConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateZapierConfig>>,
  TError,
  { data: BodyType<UpdateZapierConfigBody> },
  TContext
> => {
  const mutationKey = ["updateZapierConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateZapierConfig>>,
    { data: BodyType<UpdateZapierConfigBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateZapierConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateZapierConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateZapierConfig>>
>;
export type UpdateZapierConfigMutationBody = BodyType<UpdateZapierConfigBody>;
export type UpdateZapierConfigMutationError = ErrorType<unknown>;

/**
 * @summary Save webhook configuration
 */
export const useUpdateZapierConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateZapierConfig>>,
    TError,
    { data: BodyType<UpdateZapierConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateZapierConfig>>,
  TError,
  { data: BodyType<UpdateZapierConfigBody> },
  TContext
> => {
  return useMutation(getUpdateZapierConfigMutationOptions(options));
};

/**
 * @summary Disconnect webhook
 */
export const getDeleteZapierConfigUrl = () => {
  return `/api/zapier/config`;
};

export const deleteZapierConfig = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteZapierConfigUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteZapierConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteZapierConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteZapierConfig>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteZapierConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteZapierConfig>>,
    void
  > = () => {
    return deleteZapierConfig(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteZapierConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteZapierConfig>>
>;

export type DeleteZapierConfigMutationError = ErrorType<unknown>;

/**
 * @summary Disconnect webhook
 */
export const useDeleteZapierConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteZapierConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteZapierConfig>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteZapierConfigMutationOptions(options));
};

/**
 * @summary Send a test webhook
 */
export const getSendZapierTestUrl = () => {
  return `/api/zapier/test`;
};

export const sendZapierTest = async (
  options?: RequestInit,
): Promise<ZapierTestResponse> => {
  return customFetch<ZapierTestResponse>(getSendZapierTestUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSendZapierTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendZapierTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendZapierTest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["sendZapierTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendZapierTest>>,
    void
  > = () => {
    return sendZapierTest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendZapierTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendZapierTest>>
>;

export type SendZapierTestMutationError = ErrorType<unknown>;

/**
 * @summary Send a test webhook
 */
export const useSendZapierTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendZapierTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendZapierTest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSendZapierTestMutationOptions(options));
};

/**
 * @summary Get webhook delivery logs
 */
export const getGetZapierLogsUrl = () => {
  return `/api/zapier/logs`;
};

export const getZapierLogs = async (
  options?: RequestInit,
): Promise<ZapierLogsResponse> => {
  return customFetch<ZapierLogsResponse>(getGetZapierLogsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetZapierLogsQueryKey = () => {
  return [`/api/zapier/logs`] as const;
};

export const getGetZapierLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getZapierLogs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZapierLogs>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetZapierLogsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getZapierLogs>>> = ({
    signal,
  }) => getZapierLogs({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getZapierLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetZapierLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getZapierLogs>>
>;
export type GetZapierLogsQueryError = ErrorType<unknown>;

/**
 * @summary Get webhook delivery logs
 */

export function useGetZapierLogs<
  TData = Awaited<ReturnType<typeof getZapierLogs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZapierLogs>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetZapierLogsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Receive inbound feedback from Zapier
 */
export const getZapierInboundUrl = () => {
  return `/api/zapier/inbound`;
};

export const zapierInbound = async (
  zapierInboundBody: ZapierInboundBody,
  options?: RequestInit,
): Promise<ZapierInboundResponse> => {
  return customFetch<ZapierInboundResponse>(getZapierInboundUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(zapierInboundBody),
  });
};

export const getZapierInboundMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof zapierInbound>>,
    TError,
    { data: BodyType<ZapierInboundBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof zapierInbound>>,
  TError,
  { data: BodyType<ZapierInboundBody> },
  TContext
> => {
  const mutationKey = ["zapierInbound"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof zapierInbound>>,
    { data: BodyType<ZapierInboundBody> }
  > = (props) => {
    const { data } = props ?? {};

    return zapierInbound(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ZapierInboundMutationResult = NonNullable<
  Awaited<ReturnType<typeof zapierInbound>>
>;
export type ZapierInboundMutationBody = BodyType<ZapierInboundBody>;
export type ZapierInboundMutationError = ErrorType<unknown>;

/**
 * @summary Receive inbound feedback from Zapier
 */
export const useZapierInbound = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof zapierInbound>>,
    TError,
    { data: BodyType<ZapierInboundBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof zapierInbound>>,
  TError,
  { data: BodyType<ZapierInboundBody> },
  TContext
> => {
  return useMutation(getZapierInboundMutationOptions(options));
};

/**
 * @summary Get Google Analytics connection status
 */
export const getGetGAOAuthStatusUrl = () => {
  return `/api/google-analytics/oauth/status`;
};

export const getGAOAuthStatus = async (
  options?: RequestInit,
): Promise<GAOAuthStatus> => {
  return customFetch<GAOAuthStatus>(getGetGAOAuthStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGAOAuthStatusQueryKey = () => {
  return [`/api/google-analytics/oauth/status`] as const;
};

export const getGetGAOAuthStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getGAOAuthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGAOAuthStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGAOAuthStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGAOAuthStatus>>
  > = ({ signal }) => getGAOAuthStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGAOAuthStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGAOAuthStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGAOAuthStatus>>
>;
export type GetGAOAuthStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get Google Analytics connection status
 */

export function useGetGAOAuthStatus<
  TData = Awaited<ReturnType<typeof getGAOAuthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGAOAuthStatus>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGAOAuthStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List available GA4 properties
 */
export const getGetGAPropertiesUrl = () => {
  return `/api/google-analytics/properties`;
};

export const getGAProperties = async (
  options?: RequestInit,
): Promise<GAPropertiesResponse> => {
  return customFetch<GAPropertiesResponse>(getGetGAPropertiesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGAPropertiesQueryKey = () => {
  return [`/api/google-analytics/properties`] as const;
};

export const getGetGAPropertiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getGAProperties>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGAProperties>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGAPropertiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGAProperties>>> = ({
    signal,
  }) => getGAProperties({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGAProperties>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGAPropertiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGAProperties>>
>;
export type GetGAPropertiesQueryError = ErrorType<unknown>;

/**
 * @summary List available GA4 properties
 */

export function useGetGAProperties<
  TData = Awaited<ReturnType<typeof getGAProperties>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGAProperties>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGAPropertiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Select a GA4 property to sync
 */
export const getSelectGAPropertyUrl = () => {
  return `/api/google-analytics/properties/select`;
};

export const selectGAProperty = async (
  selectGAPropertyBody: SelectGAPropertyBody,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getSelectGAPropertyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(selectGAPropertyBody),
  });
};

export const getSelectGAPropertyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectGAProperty>>,
    TError,
    { data: BodyType<SelectGAPropertyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectGAProperty>>,
  TError,
  { data: BodyType<SelectGAPropertyBody> },
  TContext
> => {
  const mutationKey = ["selectGAProperty"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectGAProperty>>,
    { data: BodyType<SelectGAPropertyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return selectGAProperty(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectGAPropertyMutationResult = NonNullable<
  Awaited<ReturnType<typeof selectGAProperty>>
>;
export type SelectGAPropertyMutationBody = BodyType<SelectGAPropertyBody>;
export type SelectGAPropertyMutationError = ErrorType<unknown>;

/**
 * @summary Select a GA4 property to sync
 */
export const useSelectGAProperty = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectGAProperty>>,
    TError,
    { data: BodyType<SelectGAPropertyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectGAProperty>>,
  TError,
  { data: BodyType<SelectGAPropertyBody> },
  TContext
> => {
  return useMutation(getSelectGAPropertyMutationOptions(options));
};

/**
 * @summary Trigger manual GA4 sync
 */
export const getSyncGoogleAnalyticsUrl = () => {
  return `/api/google-analytics/sync`;
};

export const syncGoogleAnalytics = async (
  options?: RequestInit,
): Promise<GASyncResult> => {
  return customFetch<GASyncResult>(getSyncGoogleAnalyticsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSyncGoogleAnalyticsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncGoogleAnalytics>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncGoogleAnalytics>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncGoogleAnalytics"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncGoogleAnalytics>>,
    void
  > = () => {
    return syncGoogleAnalytics(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncGoogleAnalyticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncGoogleAnalytics>>
>;

export type SyncGoogleAnalyticsMutationError = ErrorType<unknown>;

/**
 * @summary Trigger manual GA4 sync
 */
export const useSyncGoogleAnalytics = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncGoogleAnalytics>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncGoogleAnalytics>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSyncGoogleAnalyticsMutationOptions(options));
};

/**
 * @summary Disconnect Google Analytics
 */
export const getDisconnectGoogleAnalyticsUrl = () => {
  return `/api/google-analytics/disconnect`;
};

export const disconnectGoogleAnalytics = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDisconnectGoogleAnalyticsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectGoogleAnalyticsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGoogleAnalytics>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectGoogleAnalytics>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectGoogleAnalytics"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectGoogleAnalytics>>,
    void
  > = () => {
    return disconnectGoogleAnalytics(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectGoogleAnalyticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectGoogleAnalytics>>
>;

export type DisconnectGoogleAnalyticsMutationError = ErrorType<unknown>;

/**
 * @summary Disconnect Google Analytics
 */
export const useDisconnectGoogleAnalytics = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGoogleAnalytics>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectGoogleAnalytics>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDisconnectGoogleAnalyticsMutationOptions(options));
};

/**
 * @summary Get traffic vs sentiment correlation data
 */
export const getGetAnalyticsCorrelationUrl = (
  params?: GetAnalyticsCorrelationParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/correlation?${stringifiedParams}`
    : `/api/analytics/correlation`;
};

export const getAnalyticsCorrelation = async (
  params?: GetAnalyticsCorrelationParams,
  options?: RequestInit,
): Promise<AnalyticsCorrelationResponse> => {
  return customFetch<AnalyticsCorrelationResponse>(
    getGetAnalyticsCorrelationUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAnalyticsCorrelationQueryKey = (
  params?: GetAnalyticsCorrelationParams,
) => {
  return [`/api/analytics/correlation`, ...(params ? [params] : [])] as const;
};

export const getGetAnalyticsCorrelationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsCorrelation>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnalyticsCorrelationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCorrelation>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAnalyticsCorrelationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsCorrelation>>
  > = ({ signal }) =>
    getAnalyticsCorrelation(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsCorrelation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsCorrelationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsCorrelation>>
>;
export type GetAnalyticsCorrelationQueryError = ErrorType<unknown>;

/**
 * @summary Get traffic vs sentiment correlation data
 */

export function useGetAnalyticsCorrelation<
  TData = Awaited<ReturnType<typeof getAnalyticsCorrelation>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnalyticsCorrelationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCorrelation>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsCorrelationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get current open reporting cycle
 */
export const getGetCurrentCycleUrl = () => {
  return `/api/cycles/current`;
};

export const getCurrentCycle = async (
  options?: RequestInit,
): Promise<CurrentCycle> => {
  return customFetch<CurrentCycle>(getGetCurrentCycleUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentCycleQueryKey = () => {
  return [`/api/cycles/current`] as const;
};

export const getGetCurrentCycleQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentCycle>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentCycle>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentCycleQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentCycle>>> = ({
    signal,
  }) => getCurrentCycle({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentCycle>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentCycleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentCycle>>
>;
export type GetCurrentCycleQueryError = ErrorType<unknown>;

/**
 * @summary Get current open reporting cycle
 */

export function useGetCurrentCycle<
  TData = Awaited<ReturnType<typeof getCurrentCycle>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentCycle>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentCycleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all reporting cycles
 */
export const getListCyclesUrl = () => {
  return `/api/cycles`;
};

export const listCycles = async (
  options?: RequestInit,
): Promise<ListCycles200> => {
  return customFetch<ListCycles200>(getListCyclesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCyclesQueryKey = () => {
  return [`/api/cycles`] as const;
};

export const getListCyclesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCycles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCycles>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCyclesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCycles>>> = ({
    signal,
  }) => listCycles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCycles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCyclesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCycles>>
>;
export type ListCyclesQueryError = ErrorType<unknown>;

/**
 * @summary List all reporting cycles
 */

export function useListCycles<
  TData = Awaited<ReturnType<typeof listCycles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listCycles>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCyclesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get detailed reporting cycle with recommendations
 */
export const getGetCycleDetailUrl = (id: string) => {
  return `/api/cycles/${id}`;
};

export const getCycleDetail = async (
  id: string,
  options?: RequestInit,
): Promise<CycleDetail> => {
  return customFetch<CycleDetail>(getGetCycleDetailUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCycleDetailQueryKey = (id: string) => {
  return [`/api/cycles/${id}`] as const;
};

export const getGetCycleDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getCycleDetail>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCycleDetail>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCycleDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCycleDetail>>> = ({
    signal,
  }) => getCycleDetail(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCycleDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCycleDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCycleDetail>>
>;
export type GetCycleDetailQueryError = ErrorType<unknown>;

/**
 * @summary Get detailed reporting cycle with recommendations
 */

export function useGetCycleDetail<
  TData = Awaited<ReturnType<typeof getCycleDetail>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCycleDetail>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCycleDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Close the current open cycle
 */
export const getCloseCycleUrl = () => {
  return `/api/cycles/close`;
};

export const closeCycle = async (
  options?: RequestInit,
): Promise<CycleSummary> => {
  return customFetch<CycleSummary>(getCloseCycleUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCloseCycleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeCycle>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeCycle>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["closeCycle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeCycle>>,
    void
  > = () => {
    return closeCycle(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseCycleMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeCycle>>
>;

export type CloseCycleMutationError = ErrorType<unknown>;

/**
 * @summary Close the current open cycle
 */
export const useCloseCycle = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeCycle>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof closeCycle>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCloseCycleMutationOptions(options));
};

/**
 * @summary Get onboarding state
 */
export const getGetOnboardingUrl = () => {
  return `/api/onboarding`;
};

export const getOnboarding = async (
  options?: RequestInit,
): Promise<OnboardingState> => {
  return customFetch<OnboardingState>(getGetOnboardingUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOnboardingQueryKey = () => {
  return [`/api/onboarding`] as const;
};

export const getGetOnboardingQueryOptions = <
  TData = Awaited<ReturnType<typeof getOnboarding>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOnboardingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboarding>>> = ({
    signal,
  }) => getOnboarding({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOnboarding>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOnboardingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOnboarding>>
>;
export type GetOnboardingQueryError = ErrorType<unknown>;

/**
 * @summary Get onboarding state
 */

export function useGetOnboarding<
  TData = Awaited<ReturnType<typeof getOnboarding>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOnboardingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update onboarding state
 */
export const getUpdateOnboardingUrl = () => {
  return `/api/onboarding`;
};

export const updateOnboarding = async (
  updateOnboardingBody: UpdateOnboardingBody,
  options?: RequestInit,
): Promise<OnboardingState> => {
  return customFetch<OnboardingState>(getUpdateOnboardingUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateOnboardingBody),
  });
};

export const getUpdateOnboardingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOnboarding>>,
    TError,
    { data: BodyType<UpdateOnboardingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOnboarding>>,
  TError,
  { data: BodyType<UpdateOnboardingBody> },
  TContext
> => {
  const mutationKey = ["updateOnboarding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOnboarding>>,
    { data: BodyType<UpdateOnboardingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateOnboarding(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOnboardingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOnboarding>>
>;
export type UpdateOnboardingMutationBody = BodyType<UpdateOnboardingBody>;
export type UpdateOnboardingMutationError = ErrorType<unknown>;

/**
 * @summary Update onboarding state
 */
export const useUpdateOnboarding = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOnboarding>>,
    TError,
    { data: BodyType<UpdateOnboardingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOnboarding>>,
  TError,
  { data: BodyType<UpdateOnboardingBody> },
  TContext
> => {
  return useMutation(getUpdateOnboardingMutationOptions(options));
};

/**
 * @summary Exit onboarding early, provisioning a minimal org
 */
export const getExitOnboardingUrl = () => {
  return `/api/onboarding/exit`;
};

export const exitOnboarding = async (
  exitOnboardingBody?: ExitOnboardingBody,
  options?: RequestInit,
): Promise<OnboardingState> => {
  return customFetch<OnboardingState>(getExitOnboardingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(exitOnboardingBody),
  });
};

export const getExitOnboardingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exitOnboarding>>,
    TError,
    { data: BodyType<ExitOnboardingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exitOnboarding>>,
  TError,
  { data: BodyType<ExitOnboardingBody> },
  TContext
> => {
  const mutationKey = ["exitOnboarding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exitOnboarding>>,
    { data: BodyType<ExitOnboardingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return exitOnboarding(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExitOnboardingMutationResult = NonNullable<
  Awaited<ReturnType<typeof exitOnboarding>>
>;
export type ExitOnboardingMutationBody = BodyType<ExitOnboardingBody>;
export type ExitOnboardingMutationError = ErrorType<unknown>;

/**
 * @summary Exit onboarding early, provisioning a minimal org
 */
export const useExitOnboarding = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exitOnboarding>>,
    TError,
    { data: BodyType<ExitOnboardingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exitOnboarding>>,
  TError,
  { data: BodyType<ExitOnboardingBody> },
  TContext
> => {
  return useMutation(getExitOnboardingMutationOptions(options));
};

/**
 * @summary Get billing info
 */
export const getGetBillingUrl = () => {
  return `/api/billing`;
};

export const getBilling = async (
  options?: RequestInit,
): Promise<BillingInfo> => {
  return customFetch<BillingInfo>(getGetBillingUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBillingQueryKey = () => {
  return [`/api/billing`] as const;
};

export const getGetBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getBilling>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBilling>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBillingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBilling>>> = ({
    signal,
  }) => getBilling({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBilling>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBilling>>
>;
export type GetBillingQueryError = ErrorType<unknown>;

/**
 * @summary Get billing info
 */

export function useGetBilling<
  TData = Awaited<ReturnType<typeof getBilling>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBilling>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a Stripe Checkout session for a plan
 */
export const getCreateBillingCheckoutUrl = () => {
  return `/api/billing/checkout`;
};

export const createBillingCheckout = async (
  createCheckoutBody: CreateCheckoutBody,
  options?: RequestInit,
): Promise<CreateCheckoutResponse> => {
  return customFetch<CreateCheckoutResponse>(getCreateBillingCheckoutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCheckoutBody),
  });
};

export const getCreateBillingCheckoutMutationOptions = <
  TError = ErrorType<CreateBillingCheckout503>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    TError,
    { data: BodyType<CreateCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBillingCheckout>>,
  TError,
  { data: BodyType<CreateCheckoutBody> },
  TContext
> => {
  const mutationKey = ["createBillingCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    { data: BodyType<CreateCheckoutBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBillingCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBillingCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBillingCheckout>>
>;
export type CreateBillingCheckoutMutationBody = BodyType<CreateCheckoutBody>;
export type CreateBillingCheckoutMutationError =
  ErrorType<CreateBillingCheckout503>;

/**
 * @summary Create a Stripe Checkout session for a plan
 */
export const useCreateBillingCheckout = <
  TError = ErrorType<CreateBillingCheckout503>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBillingCheckout>>,
    TError,
    { data: BodyType<CreateCheckoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBillingCheckout>>,
  TError,
  { data: BodyType<CreateCheckoutBody> },
  TContext
> => {
  return useMutation(getCreateBillingCheckoutMutationOptions(options));
};

/**
 * @summary Upgrade plan
 */
export const getUpgradePlanUrl = () => {
  return `/api/billing/upgrade`;
};

export const upgradePlan = async (
  upgradePlanBody: UpgradePlanBody,
  options?: RequestInit,
): Promise<BillingInfo> => {
  return customFetch<BillingInfo>(getUpgradePlanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upgradePlanBody),
  });
};

export const getUpgradePlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  const mutationKey = ["upgradePlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradePlan>>,
    { data: BodyType<UpgradePlanBody> }
  > = (props) => {
    const { data } = props ?? {};

    return upgradePlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradePlan>>
>;
export type UpgradePlanMutationBody = BodyType<UpgradePlanBody>;
export type UpgradePlanMutationError = ErrorType<unknown>;

/**
 * @summary Upgrade plan
 */
export const useUpgradePlan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  return useMutation(getUpgradePlanMutationOptions(options));
};

/**
 * @summary List the caller's Stripe invoices (purchase history)
 */
export const getGetBillingInvoicesUrl = () => {
  return `/api/billing/invoices`;
};

export const getBillingInvoices = async (
  options?: RequestInit,
): Promise<BillingInvoicesResponse> => {
  return customFetch<BillingInvoicesResponse>(getGetBillingInvoicesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBillingInvoicesQueryKey = () => {
  return [`/api/billing/invoices`] as const;
};

export const getGetBillingInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBillingInvoicesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBillingInvoices>>
  > = ({ signal }) => getBillingInvoices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingInvoices>>
>;
export type GetBillingInvoicesQueryError = ErrorType<unknown>;

/**
 * @summary List the caller's Stripe invoices (purchase history)
 */

export function useGetBillingInvoices<
  TData = Awaited<ReturnType<typeof getBillingInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingInvoicesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List notebooks for the current user
 */
export const getListNotebooksUrl = (params?: ListNotebooksParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/notebooks?${stringifiedParams}`
    : `/api/notebooks`;
};

export const listNotebooks = async (
  params?: ListNotebooksParams,
  options?: RequestInit,
): Promise<ListNotebooksResponse> => {
  return customFetch<ListNotebooksResponse>(getListNotebooksUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListNotebooksQueryKey = (params?: ListNotebooksParams) => {
  return [`/api/notebooks`, ...(params ? [params] : [])] as const;
};

export const getListNotebooksQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotebooks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotebooksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotebooks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotebooksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotebooks>>> = ({
    signal,
  }) => listNotebooks(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotebooks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotebooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotebooks>>
>;
export type ListNotebooksQueryError = ErrorType<unknown>;

/**
 * @summary List notebooks for the current user
 */

export function useListNotebooks<
  TData = Awaited<ReturnType<typeof listNotebooks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotebooksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotebooks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotebooksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new notebook
 */
export const getCreateNotebookUrl = () => {
  return `/api/notebooks`;
};

export const createNotebook = async (
  createNotebookBody: CreateNotebookBody,
  options?: RequestInit,
): Promise<NotebookResponse> => {
  return customFetch<NotebookResponse>(getCreateNotebookUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createNotebookBody),
  });
};

export const getCreateNotebookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNotebook>>,
    TError,
    { data: BodyType<CreateNotebookBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNotebook>>,
  TError,
  { data: BodyType<CreateNotebookBody> },
  TContext
> => {
  const mutationKey = ["createNotebook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNotebook>>,
    { data: BodyType<CreateNotebookBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createNotebook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNotebookMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNotebook>>
>;
export type CreateNotebookMutationBody = BodyType<CreateNotebookBody>;
export type CreateNotebookMutationError = ErrorType<unknown>;

/**
 * @summary Create a new notebook
 */
export const useCreateNotebook = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNotebook>>,
    TError,
    { data: BodyType<CreateNotebookBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNotebook>>,
  TError,
  { data: BodyType<CreateNotebookBody> },
  TContext
> => {
  return useMutation(getCreateNotebookMutationOptions(options));
};

/**
 * @summary Get a single notebook with its tasks
 */
export const getGetNotebookUrl = (id: string) => {
  return `/api/notebooks/${id}`;
};

export const getNotebook = async (
  id: string,
  options?: RequestInit,
): Promise<NotebookDetailResponse> => {
  return customFetch<NotebookDetailResponse>(getGetNotebookUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetNotebookQueryKey = (id: string) => {
  return [`/api/notebooks/${id}`] as const;
};

export const getGetNotebookQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotebook>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotebook>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotebookQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotebook>>> = ({
    signal,
  }) => getNotebook(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotebook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotebookQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotebook>>
>;
export type GetNotebookQueryError = ErrorType<void>;

/**
 * @summary Get a single notebook with its tasks
 */

export function useGetNotebook<
  TData = Awaited<ReturnType<typeof getNotebook>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotebook>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotebookQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update notebook title or content
 */
export const getUpdateNotebookUrl = (id: string) => {
  return `/api/notebooks/${id}`;
};

export const updateNotebook = async (
  id: string,
  updateNotebookBody: UpdateNotebookBody,
  options?: RequestInit,
): Promise<NotebookResponse> => {
  return customFetch<NotebookResponse>(getUpdateNotebookUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateNotebookBody),
  });
};

export const getUpdateNotebookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotebook>>,
    TError,
    { id: string; data: BodyType<UpdateNotebookBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotebook>>,
  TError,
  { id: string; data: BodyType<UpdateNotebookBody> },
  TContext
> => {
  const mutationKey = ["updateNotebook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotebook>>,
    { id: string; data: BodyType<UpdateNotebookBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateNotebook(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotebookMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotebook>>
>;
export type UpdateNotebookMutationBody = BodyType<UpdateNotebookBody>;
export type UpdateNotebookMutationError = ErrorType<unknown>;

/**
 * @summary Update notebook title or content
 */
export const useUpdateNotebook = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotebook>>,
    TError,
    { id: string; data: BodyType<UpdateNotebookBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotebook>>,
  TError,
  { id: string; data: BodyType<UpdateNotebookBody> },
  TContext
> => {
  return useMutation(getUpdateNotebookMutationOptions(options));
};

/**
 * @summary Delete a notebook and all its tasks
 */
export const getDeleteNotebookUrl = (id: string) => {
  return `/api/notebooks/${id}`;
};

export const deleteNotebook = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteNotebookUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteNotebookMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotebook>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNotebook>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteNotebook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNotebook>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteNotebook(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNotebookMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNotebook>>
>;

export type DeleteNotebookMutationError = ErrorType<unknown>;

/**
 * @summary Delete a notebook and all its tasks
 */
export const useDeleteNotebook = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotebook>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNotebook>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteNotebookMutationOptions(options));
};

/**
 * @summary List tasks for a notebook
 */
export const getListNotebookTasksUrl = (id: string) => {
  return `/api/notebooks/${id}/tasks`;
};

export const listNotebookTasks = async (
  id: string,
  options?: RequestInit,
): Promise<ListNotebookTasksResponse> => {
  return customFetch<ListNotebookTasksResponse>(getListNotebookTasksUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListNotebookTasksQueryKey = (id: string) => {
  return [`/api/notebooks/${id}/tasks`] as const;
};

export const getListNotebookTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotebookTasks>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotebookTasks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotebookTasksQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotebookTasks>>
  > = ({ signal }) => listNotebookTasks(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotebookTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotebookTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotebookTasks>>
>;
export type ListNotebookTasksQueryError = ErrorType<unknown>;

/**
 * @summary List tasks for a notebook
 */

export function useListNotebookTasks<
  TData = Awaited<ReturnType<typeof listNotebookTasks>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotebookTasks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotebookTasksQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a task in a notebook
 */
export const getCreateNotebookTaskUrl = (id: string) => {
  return `/api/notebooks/${id}/tasks`;
};

export const createNotebookTask = async (
  id: string,
  createNotebookTaskBody: CreateNotebookTaskBody,
  options?: RequestInit,
): Promise<NotebookTaskResponse> => {
  return customFetch<NotebookTaskResponse>(getCreateNotebookTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createNotebookTaskBody),
  });
};

export const getCreateNotebookTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNotebookTask>>,
    TError,
    { id: string; data: BodyType<CreateNotebookTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNotebookTask>>,
  TError,
  { id: string; data: BodyType<CreateNotebookTaskBody> },
  TContext
> => {
  const mutationKey = ["createNotebookTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNotebookTask>>,
    { id: string; data: BodyType<CreateNotebookTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createNotebookTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNotebookTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNotebookTask>>
>;
export type CreateNotebookTaskMutationBody = BodyType<CreateNotebookTaskBody>;
export type CreateNotebookTaskMutationError = ErrorType<unknown>;

/**
 * @summary Create a task in a notebook
 */
export const useCreateNotebookTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNotebookTask>>,
    TError,
    { id: string; data: BodyType<CreateNotebookTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNotebookTask>>,
  TError,
  { id: string; data: BodyType<CreateNotebookTaskBody> },
  TContext
> => {
  return useMutation(getCreateNotebookTaskMutationOptions(options));
};

/**
 * @summary Update a notebook task
 */
export const getUpdateNotebookTaskUrl = (id: string, taskId: string) => {
  return `/api/notebooks/${id}/tasks/${taskId}`;
};

export const updateNotebookTask = async (
  id: string,
  taskId: string,
  updateNotebookTaskBody: UpdateNotebookTaskBody,
  options?: RequestInit,
): Promise<NotebookTaskResponse> => {
  return customFetch<NotebookTaskResponse>(
    getUpdateNotebookTaskUrl(id, taskId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateNotebookTaskBody),
    },
  );
};

export const getUpdateNotebookTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotebookTask>>,
    TError,
    { id: string; taskId: string; data: BodyType<UpdateNotebookTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotebookTask>>,
  TError,
  { id: string; taskId: string; data: BodyType<UpdateNotebookTaskBody> },
  TContext
> => {
  const mutationKey = ["updateNotebookTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotebookTask>>,
    { id: string; taskId: string; data: BodyType<UpdateNotebookTaskBody> }
  > = (props) => {
    const { id, taskId, data } = props ?? {};

    return updateNotebookTask(id, taskId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotebookTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotebookTask>>
>;
export type UpdateNotebookTaskMutationBody = BodyType<UpdateNotebookTaskBody>;
export type UpdateNotebookTaskMutationError = ErrorType<unknown>;

/**
 * @summary Update a notebook task
 */
export const useUpdateNotebookTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotebookTask>>,
    TError,
    { id: string; taskId: string; data: BodyType<UpdateNotebookTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotebookTask>>,
  TError,
  { id: string; taskId: string; data: BodyType<UpdateNotebookTaskBody> },
  TContext
> => {
  return useMutation(getUpdateNotebookTaskMutationOptions(options));
};

/**
 * @summary Delete a notebook task
 */
export const getDeleteNotebookTaskUrl = (id: string, taskId: string) => {
  return `/api/notebooks/${id}/tasks/${taskId}`;
};

export const deleteNotebookTask = async (
  id: string,
  taskId: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteNotebookTaskUrl(id, taskId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteNotebookTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotebookTask>>,
    TError,
    { id: string; taskId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNotebookTask>>,
  TError,
  { id: string; taskId: string },
  TContext
> => {
  const mutationKey = ["deleteNotebookTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNotebookTask>>,
    { id: string; taskId: string }
  > = (props) => {
    const { id, taskId } = props ?? {};

    return deleteNotebookTask(id, taskId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNotebookTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNotebookTask>>
>;

export type DeleteNotebookTaskMutationError = ErrorType<unknown>;

/**
 * @summary Delete a notebook task
 */
export const useDeleteNotebookTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotebookTask>>,
    TError,
    { id: string; taskId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNotebookTask>>,
  TError,
  { id: string; taskId: string },
  TContext
> => {
  return useMutation(getDeleteNotebookTaskMutationOptions(options));
};

/**
 * @summary List org tasks
 */
export const getListTasksUrl = (params?: ListTasksParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tasks?${stringifiedParams}`
    : `/api/tasks`;
};

export const listTasks = async (
  params?: ListTasksParams,
  options?: RequestInit,
): Promise<ListTasksResponse> => {
  return customFetch<ListTasksResponse>(getListTasksUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTasksQueryKey = (params?: ListTasksParams) => {
  return [`/api/tasks`, ...(params ? [params] : [])] as const;
};

export const getListTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({
    signal,
  }) => listTasks(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTasks>>
>;
export type ListTasksQueryError = ErrorType<unknown>;

/**
 * @summary List org tasks
 */

export function useListTasks<
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a task
 */
export const getCreateTaskUrl = () => {
  return `/api/tasks`;
};

export const createTask = async (
  createTaskBody: CreateTaskBody,
  options?: RequestInit,
): Promise<TaskResponse> => {
  return customFetch<TaskResponse>(getCreateTaskUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskBody),
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskBody> },
  TContext
> => {
  const mutationKey = ["createTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { data: BodyType<CreateTaskBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTask>>
>;
export type CreateTaskMutationBody = BodyType<CreateTaskBody>;
export type CreateTaskMutationError = ErrorType<unknown>;

/**
 * @summary Create a task
 */
export const useCreateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskBody> },
  TContext
> => {
  return useMutation(getCreateTaskMutationOptions(options));
};

/**
 * @summary Update a task
 */
export const getUpdateTaskUrl = (id: string) => {
  return `/api/tasks/${id}`;
};

export const updateTask = async (
  id: string,
  updateTaskBody: UpdateTaskBody,
  options?: RequestInit,
): Promise<TaskResponse> => {
  return customFetch<TaskResponse>(getUpdateTaskUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaskBody),
  });
};

export const getUpdateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: string; data: BodyType<UpdateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: string; data: BodyType<UpdateTaskBody> },
  TContext
> => {
  const mutationKey = ["updateTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { id: string; data: BodyType<UpdateTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTask>>
>;
export type UpdateTaskMutationBody = BodyType<UpdateTaskBody>;
export type UpdateTaskMutationError = ErrorType<unknown>;

/**
 * @summary Update a task
 */
export const useUpdateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: string; data: BodyType<UpdateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: string; data: BodyType<UpdateTaskBody> },
  TContext
> => {
  return useMutation(getUpdateTaskMutationOptions(options));
};

/**
 * @summary Delete a task
 */
export const getDeleteTaskUrl = (id: string) => {
  return `/api/tasks/${id}`;
};

export const deleteTask = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteTaskUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTask>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTask>>
>;

export type DeleteTaskMutationError = ErrorType<unknown>;

/**
 * @summary Delete a task
 */
export const useDeleteTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTaskMutationOptions(options));
};

/**
 * @summary List all tenants (super_admin only)
 */
export const getListAdminTenantsUrl = (params?: ListAdminTenantsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/tenants?${stringifiedParams}`
    : `/api/admin/tenants`;
};

export const listAdminTenants = async (
  params?: ListAdminTenantsParams,
  options?: RequestInit,
): Promise<AdminTenantsResponse> => {
  return customFetch<AdminTenantsResponse>(getListAdminTenantsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAdminTenantsQueryKey = (
  params?: ListAdminTenantsParams,
) => {
  return [`/api/admin/tenants`, ...(params ? [params] : [])] as const;
};

export const getListAdminTenantsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminTenants>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminTenantsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminTenants>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminTenantsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminTenants>>
  > = ({ signal }) => listAdminTenants(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminTenants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminTenantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminTenants>>
>;
export type ListAdminTenantsQueryError = ErrorType<unknown>;

/**
 * @summary List all tenants (super_admin only)
 */

export function useListAdminTenants<
  TData = Awaited<ReturnType<typeof listAdminTenants>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminTenantsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminTenants>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminTenantsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new tenant
 */
export const getCreateAdminTenantUrl = () => {
  return `/api/admin/tenants`;
};

export const createAdminTenant = async (
  createAdminTenantBody: CreateAdminTenantBody,
  options?: RequestInit,
): Promise<CreateAdminTenant200> => {
  return customFetch<CreateAdminTenant200>(getCreateAdminTenantUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAdminTenantBody),
  });
};

export const getCreateAdminTenantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminTenant>>,
    TError,
    { data: BodyType<CreateAdminTenantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminTenant>>,
  TError,
  { data: BodyType<CreateAdminTenantBody> },
  TContext
> => {
  const mutationKey = ["createAdminTenant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminTenant>>,
    { data: BodyType<CreateAdminTenantBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAdminTenant(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminTenant>>
>;
export type CreateAdminTenantMutationBody = BodyType<CreateAdminTenantBody>;
export type CreateAdminTenantMutationError = ErrorType<unknown>;

/**
 * @summary Create a new tenant
 */
export const useCreateAdminTenant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminTenant>>,
    TError,
    { data: BodyType<CreateAdminTenantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAdminTenant>>,
  TError,
  { data: BodyType<CreateAdminTenantBody> },
  TContext
> => {
  return useMutation(getCreateAdminTenantMutationOptions(options));
};

/**
 * Idempotent per-id bulk action. A failure on one id never aborts the batch — every id gets its own entry in `results`.
 * @summary Bulk archive or re-scan tenants (super_admin only)
 */
export const getBulkAdminTenantActionUrl = () => {
  return `/api/admin/tenants/bulk`;
};

export const bulkAdminTenantAction = async (
  bulkActionRequest: BulkActionRequest,
  options?: RequestInit,
): Promise<BulkActionResponse> => {
  return customFetch<BulkActionResponse>(getBulkAdminTenantActionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkActionRequest),
  });
};

export const getBulkAdminTenantActionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkAdminTenantAction>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkAdminTenantAction>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  const mutationKey = ["bulkAdminTenantAction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkAdminTenantAction>>,
    { data: BodyType<BulkActionRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkAdminTenantAction(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkAdminTenantActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkAdminTenantAction>>
>;
export type BulkAdminTenantActionMutationBody = BodyType<BulkActionRequest>;
export type BulkAdminTenantActionMutationError = ErrorType<unknown>;

/**
 * @summary Bulk archive or re-scan tenants (super_admin only)
 */
export const useBulkAdminTenantAction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkAdminTenantAction>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkAdminTenantAction>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  return useMutation(getBulkAdminTenantActionMutationOptions(options));
};

/**
 * @summary Get tenant detail
 */
export const getGetAdminTenantUrl = (id: string) => {
  return `/api/admin/tenants/${id}`;
};

export const getAdminTenant = async (
  id: string,
  options?: RequestInit,
): Promise<AdminTenantDetailResponse> => {
  return customFetch<AdminTenantDetailResponse>(getGetAdminTenantUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminTenantQueryKey = (id: string) => {
  return [`/api/admin/tenants/${id}`] as const;
};

export const getGetAdminTenantQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminTenant>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTenant>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminTenantQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTenant>>> = ({
    signal,
  }) => getAdminTenant(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminTenant>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminTenantQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenant>>
>;
export type GetAdminTenantQueryError = ErrorType<unknown>;

/**
 * @summary Get tenant detail
 */

export function useGetAdminTenant<
  TData = Awaited<ReturnType<typeof getAdminTenant>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTenant>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminTenantQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a tenant
 */
export const getUpdateAdminTenantUrl = (id: string) => {
  return `/api/admin/tenants/${id}`;
};

export const updateAdminTenant = async (
  id: string,
  updateAdminTenantBody: UpdateAdminTenantBody,
  options?: RequestInit,
): Promise<UpdateAdminTenant200> => {
  return customFetch<UpdateAdminTenant200>(getUpdateAdminTenantUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAdminTenantBody),
  });
};

export const getUpdateAdminTenantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminTenant>>,
    TError,
    { id: string; data: BodyType<UpdateAdminTenantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminTenant>>,
  TError,
  { id: string; data: BodyType<UpdateAdminTenantBody> },
  TContext
> => {
  const mutationKey = ["updateAdminTenant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminTenant>>,
    { id: string; data: BodyType<UpdateAdminTenantBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAdminTenant(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminTenant>>
>;
export type UpdateAdminTenantMutationBody = BodyType<UpdateAdminTenantBody>;
export type UpdateAdminTenantMutationError = ErrorType<unknown>;

/**
 * @summary Update a tenant
 */
export const useUpdateAdminTenant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminTenant>>,
    TError,
    { id: string; data: BodyType<UpdateAdminTenantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminTenant>>,
  TError,
  { id: string; data: BodyType<UpdateAdminTenantBody> },
  TContext
> => {
  return useMutation(getUpdateAdminTenantMutationOptions(options));
};

/**
 * @summary Delete a tenant
 */
export const getDeleteAdminTenantUrl = (id: string) => {
  return `/api/admin/tenants/${id}`;
};

export const deleteAdminTenant = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteAdminTenantUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminTenantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminTenant>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminTenant>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteAdminTenant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminTenant>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminTenant(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminTenant>>
>;

export type DeleteAdminTenantMutationError = ErrorType<unknown>;

/**
 * @summary Delete a tenant
 */
export const useDeleteAdminTenant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminTenant>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminTenant>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteAdminTenantMutationOptions(options));
};

/**
 * Permanently deletes all reviews for the given tenant. Requires super_admin role. The caller must confirm by posting the exact tenant name in the request body. Records a history entry noting who wiped how many reviews.
 * @summary Wipe every review for a tenant (super_admin only)
 */
export const getWipeAdminTenantReviewsUrl = (id: string) => {
  return `/api/admin/tenants/${id}/wipe-reviews`;
};

export const wipeAdminTenantReviews = async (
  id: string,
  wipeAdminTenantReviewsBody: WipeAdminTenantReviewsBody,
  options?: RequestInit,
): Promise<WipeAdminTenantReviews200> => {
  return customFetch<WipeAdminTenantReviews200>(
    getWipeAdminTenantReviewsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(wipeAdminTenantReviewsBody),
    },
  );
};

export const getWipeAdminTenantReviewsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wipeAdminTenantReviews>>,
    TError,
    { id: string; data: BodyType<WipeAdminTenantReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wipeAdminTenantReviews>>,
  TError,
  { id: string; data: BodyType<WipeAdminTenantReviewsBody> },
  TContext
> => {
  const mutationKey = ["wipeAdminTenantReviews"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wipeAdminTenantReviews>>,
    { id: string; data: BodyType<WipeAdminTenantReviewsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return wipeAdminTenantReviews(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WipeAdminTenantReviewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof wipeAdminTenantReviews>>
>;
export type WipeAdminTenantReviewsMutationBody =
  BodyType<WipeAdminTenantReviewsBody>;
export type WipeAdminTenantReviewsMutationError = ErrorType<unknown>;

/**
 * @summary Wipe every review for a tenant (super_admin only)
 */
export const useWipeAdminTenantReviews = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wipeAdminTenantReviews>>,
    TError,
    { id: string; data: BodyType<WipeAdminTenantReviewsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof wipeAdminTenantReviews>>,
  TError,
  { id: string; data: BodyType<WipeAdminTenantReviewsBody> },
  TContext
> => {
  return useMutation(getWipeAdminTenantReviewsMutationOptions(options));
};

/**
 * @summary List all users across tenants
 */
export const getListAdminUsersUrl = (params?: ListAdminUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/users?${stringifiedParams}`
    : `/api/admin/users`;
};

export const listAdminUsers = async (
  params?: ListAdminUsersParams,
  options?: RequestInit,
): Promise<AdminUsersResponse> => {
  return customFetch<AdminUsersResponse>(getListAdminUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAdminUsersQueryKey = (params?: ListAdminUsersParams) => {
  return [`/api/admin/users`, ...(params ? [params] : [])] as const;
};

export const getListAdminUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminUsers>>> = ({
    signal,
  }) => listAdminUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminUsers>>
>;
export type ListAdminUsersQueryError = ErrorType<unknown>;

/**
 * @summary List all users across tenants
 */

export function useListAdminUsers<
  TData = Awaited<ReturnType<typeof listAdminUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new platform user
 */
export const getCreateAdminUserUrl = () => {
  return `/api/admin/users`;
};

export const createAdminUser = async (
  createAdminUserBody: CreateAdminUserBody,
  options?: RequestInit,
): Promise<AdminUserResponse> => {
  return customFetch<AdminUserResponse>(getCreateAdminUserUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAdminUserBody),
  });
};

export const getCreateAdminUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminUser>>,
    TError,
    { data: BodyType<CreateAdminUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminUser>>,
  TError,
  { data: BodyType<CreateAdminUserBody> },
  TContext
> => {
  const mutationKey = ["createAdminUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminUser>>,
    { data: BodyType<CreateAdminUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAdminUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminUser>>
>;
export type CreateAdminUserMutationBody = BodyType<CreateAdminUserBody>;
export type CreateAdminUserMutationError = ErrorType<unknown>;

/**
 * @summary Create a new platform user
 */
export const useCreateAdminUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminUser>>,
    TError,
    { data: BodyType<CreateAdminUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAdminUser>>,
  TError,
  { data: BodyType<CreateAdminUserBody> },
  TContext
> => {
  return useMutation(getCreateAdminUserMutationOptions(options));
};

/**
 * @summary Update a user (disabled, role, name, plan)
 */
export const getUpdateAdminUserUrl = (id: string) => {
  return `/api/admin/users/${id}`;
};

export const updateAdminUser = async (
  id: string,
  updateAdminUserBody: UpdateAdminUserBody,
  options?: RequestInit,
): Promise<UpdateAdminUser200> => {
  return customFetch<UpdateAdminUser200>(getUpdateAdminUserUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAdminUserBody),
  });
};

export const getUpdateAdminUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminUser>>,
    TError,
    { id: string; data: BodyType<UpdateAdminUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminUser>>,
  TError,
  { id: string; data: BodyType<UpdateAdminUserBody> },
  TContext
> => {
  const mutationKey = ["updateAdminUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminUser>>,
    { id: string; data: BodyType<UpdateAdminUserBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAdminUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminUser>>
>;
export type UpdateAdminUserMutationBody = BodyType<UpdateAdminUserBody>;
export type UpdateAdminUserMutationError = ErrorType<unknown>;

/**
 * @summary Update a user (disabled, role, name, plan)
 */
export const useUpdateAdminUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminUser>>,
    TError,
    { id: string; data: BodyType<UpdateAdminUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminUser>>,
  TError,
  { id: string; data: BodyType<UpdateAdminUserBody> },
  TContext
> => {
  return useMutation(getUpdateAdminUserMutationOptions(options));
};

/**
 * @summary Delete a user and their profile
 */
export const getDeleteAdminUserUrl = (id: string) => {
  return `/api/admin/users/${id}`;
};

export const deleteAdminUser = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteAdminUserUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteAdminUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminUser>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminUser(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminUser>>
>;

export type DeleteAdminUserMutationError = ErrorType<unknown>;

/**
 * @summary Delete a user and their profile
 */
export const useDeleteAdminUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminUser>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteAdminUserMutationOptions(options));
};

/**
 * @summary Assign an unaffiliated user to an organization
 */
export const getAssignOrgAdminUserUrl = (id: string) => {
  return `/api/admin/users/${id}/assign-org`;
};

export const assignOrgAdminUser = async (
  id: string,
  assignOrgAdminUserBody: AssignOrgAdminUserBody,
  options?: RequestInit,
): Promise<AssignOrgAdminUser200> => {
  return customFetch<AssignOrgAdminUser200>(getAssignOrgAdminUserUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignOrgAdminUserBody),
  });
};

export const getAssignOrgAdminUserMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignOrgAdminUser>>,
    TError,
    { id: string; data: BodyType<AssignOrgAdminUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignOrgAdminUser>>,
  TError,
  { id: string; data: BodyType<AssignOrgAdminUserBody> },
  TContext
> => {
  const mutationKey = ["assignOrgAdminUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignOrgAdminUser>>,
    { id: string; data: BodyType<AssignOrgAdminUserBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignOrgAdminUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignOrgAdminUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignOrgAdminUser>>
>;
export type AssignOrgAdminUserMutationBody = BodyType<AssignOrgAdminUserBody>;
export type AssignOrgAdminUserMutationError = ErrorType<void>;

/**
 * @summary Assign an unaffiliated user to an organization
 */
export const useAssignOrgAdminUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignOrgAdminUser>>,
    TError,
    { id: string; data: BodyType<AssignOrgAdminUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignOrgAdminUser>>,
  TError,
  { id: string; data: BodyType<AssignOrgAdminUserBody> },
  TContext
> => {
  return useMutation(getAssignOrgAdminUserMutationOptions(options));
};

/**
 * @summary Send an invite email to a user
 */
export const getInviteAdminUserUrl = (id: string) => {
  return `/api/admin/users/${id}/invite`;
};

export const inviteAdminUser = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getInviteAdminUserUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getInviteAdminUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteAdminUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteAdminUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["inviteAdminUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteAdminUser>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return inviteAdminUser(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteAdminUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteAdminUser>>
>;

export type InviteAdminUserMutationError = ErrorType<unknown>;

/**
 * @summary Send an invite email to a user
 */
export const useInviteAdminUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteAdminUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteAdminUser>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getInviteAdminUserMutationOptions(options));
};

/**
 * @summary List org link/unlink audit events for a sales lead
 */
export const getListAdminSalesLeadOrgLinkEventsUrl = (id: string) => {
  return `/api/admin/sales-leads/${id}/org-link-events`;
};

export const listAdminSalesLeadOrgLinkEvents = async (
  id: string,
  options?: RequestInit,
): Promise<AdminLeadOrgLinkEventsResponse> => {
  return customFetch<AdminLeadOrgLinkEventsResponse>(
    getListAdminSalesLeadOrgLinkEventsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminSalesLeadOrgLinkEventsQueryKey = (id: string) => {
  return [`/api/admin/sales-leads/${id}/org-link-events`] as const;
};

export const getListAdminSalesLeadOrgLinkEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminSalesLeadOrgLinkEvents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSalesLeadOrgLinkEvents>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminSalesLeadOrgLinkEventsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminSalesLeadOrgLinkEvents>>
  > = ({ signal }) =>
    listAdminSalesLeadOrgLinkEvents(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminSalesLeadOrgLinkEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminSalesLeadOrgLinkEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminSalesLeadOrgLinkEvents>>
>;
export type ListAdminSalesLeadOrgLinkEventsQueryError = ErrorType<unknown>;

/**
 * @summary List org link/unlink audit events for a sales lead
 */

export function useListAdminSalesLeadOrgLinkEvents<
  TData = Awaited<ReturnType<typeof listAdminSalesLeadOrgLinkEvents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSalesLeadOrgLinkEvents>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminSalesLeadOrgLinkEventsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List lead link/unlink audit events for an organisation
 */
export const getListAdminOrgLeadLinkEventsUrl = (id: string) => {
  return `/api/admin/orgs/${id}/lead-link-events`;
};

export const listAdminOrgLeadLinkEvents = async (
  id: string,
  options?: RequestInit,
): Promise<AdminOrgLeadLinkEventsResponse> => {
  return customFetch<AdminOrgLeadLinkEventsResponse>(
    getListAdminOrgLeadLinkEventsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminOrgLeadLinkEventsQueryKey = (id: string) => {
  return [`/api/admin/orgs/${id}/lead-link-events`] as const;
};

export const getListAdminOrgLeadLinkEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminOrgLeadLinkEvents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrgLeadLinkEvents>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminOrgLeadLinkEventsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminOrgLeadLinkEvents>>
  > = ({ signal }) =>
    listAdminOrgLeadLinkEvents(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminOrgLeadLinkEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminOrgLeadLinkEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminOrgLeadLinkEvents>>
>;
export type ListAdminOrgLeadLinkEventsQueryError = ErrorType<unknown>;

/**
 * @summary List lead link/unlink audit events for an organisation
 */

export function useListAdminOrgLeadLinkEvents<
  TData = Awaited<ReturnType<typeof listAdminOrgLeadLinkEvents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrgLeadLinkEvents>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminOrgLeadLinkEventsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List notes for a CRM contact (user/org/lead)
 */
export const getListAdminContactNotesUrl = (contactId: string) => {
  return `/api/admin/contacts/${contactId}/notes`;
};

export const listAdminContactNotes = async (
  contactId: string,
  options?: RequestInit,
): Promise<AdminContactNotesResponse> => {
  return customFetch<AdminContactNotesResponse>(
    getListAdminContactNotesUrl(contactId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminContactNotesQueryKey = (contactId: string) => {
  return [`/api/admin/contacts/${contactId}/notes`] as const;
};

export const getListAdminContactNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminContactNotes>>,
  TError = ErrorType<unknown>,
>(
  contactId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminContactNotes>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminContactNotesQueryKey(contactId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminContactNotes>>
  > = ({ signal }) =>
    listAdminContactNotes(contactId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminContactNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminContactNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminContactNotes>>
>;
export type ListAdminContactNotesQueryError = ErrorType<unknown>;

/**
 * @summary List notes for a CRM contact (user/org/lead)
 */

export function useListAdminContactNotes<
  TData = Awaited<ReturnType<typeof listAdminContactNotes>>,
  TError = ErrorType<unknown>,
>(
  contactId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminContactNotes>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminContactNotesQueryOptions(contactId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a note to a CRM contact
 */
export const getCreateAdminContactNoteUrl = (contactId: string) => {
  return `/api/admin/contacts/${contactId}/notes`;
};

export const createAdminContactNote = async (
  contactId: string,
  createAdminContactNoteBody: CreateAdminContactNoteBody,
  options?: RequestInit,
): Promise<AdminContactNoteResponse> => {
  return customFetch<AdminContactNoteResponse>(
    getCreateAdminContactNoteUrl(contactId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createAdminContactNoteBody),
    },
  );
};

export const getCreateAdminContactNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminContactNote>>,
    TError,
    { contactId: string; data: BodyType<CreateAdminContactNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminContactNote>>,
  TError,
  { contactId: string; data: BodyType<CreateAdminContactNoteBody> },
  TContext
> => {
  const mutationKey = ["createAdminContactNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminContactNote>>,
    { contactId: string; data: BodyType<CreateAdminContactNoteBody> }
  > = (props) => {
    const { contactId, data } = props ?? {};

    return createAdminContactNote(contactId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminContactNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminContactNote>>
>;
export type CreateAdminContactNoteMutationBody =
  BodyType<CreateAdminContactNoteBody>;
export type CreateAdminContactNoteMutationError = ErrorType<unknown>;

/**
 * @summary Add a note to a CRM contact
 */
export const useCreateAdminContactNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminContactNote>>,
    TError,
    { contactId: string; data: BodyType<CreateAdminContactNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAdminContactNote>>,
  TError,
  { contactId: string; data: BodyType<CreateAdminContactNoteBody> },
  TContext
> => {
  return useMutation(getCreateAdminContactNoteMutationOptions(options));
};

/**
 * @summary Edit a contact note (author or super_admin only)
 */
export const getUpdateAdminContactNoteUrl = (
  contactId: string,
  noteId: string,
) => {
  return `/api/admin/contacts/${contactId}/notes/${noteId}`;
};

export const updateAdminContactNote = async (
  contactId: string,
  noteId: string,
  updateAdminContactNoteBody: UpdateAdminContactNoteBody,
  options?: RequestInit,
): Promise<AdminContactNoteResponse> => {
  return customFetch<AdminContactNoteResponse>(
    getUpdateAdminContactNoteUrl(contactId, noteId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateAdminContactNoteBody),
    },
  );
};

export const getUpdateAdminContactNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminContactNote>>,
    TError,
    {
      contactId: string;
      noteId: string;
      data: BodyType<UpdateAdminContactNoteBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminContactNote>>,
  TError,
  {
    contactId: string;
    noteId: string;
    data: BodyType<UpdateAdminContactNoteBody>;
  },
  TContext
> => {
  const mutationKey = ["updateAdminContactNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminContactNote>>,
    {
      contactId: string;
      noteId: string;
      data: BodyType<UpdateAdminContactNoteBody>;
    }
  > = (props) => {
    const { contactId, noteId, data } = props ?? {};

    return updateAdminContactNote(contactId, noteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminContactNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminContactNote>>
>;
export type UpdateAdminContactNoteMutationBody =
  BodyType<UpdateAdminContactNoteBody>;
export type UpdateAdminContactNoteMutationError = ErrorType<unknown>;

/**
 * @summary Edit a contact note (author or super_admin only)
 */
export const useUpdateAdminContactNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminContactNote>>,
    TError,
    {
      contactId: string;
      noteId: string;
      data: BodyType<UpdateAdminContactNoteBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminContactNote>>,
  TError,
  {
    contactId: string;
    noteId: string;
    data: BodyType<UpdateAdminContactNoteBody>;
  },
  TContext
> => {
  return useMutation(getUpdateAdminContactNoteMutationOptions(options));
};

/**
 * @summary Delete a contact note (author or super_admin only)
 */
export const getDeleteAdminContactNoteUrl = (
  contactId: string,
  noteId: string,
) => {
  return `/api/admin/contacts/${contactId}/notes/${noteId}`;
};

export const deleteAdminContactNote = async (
  contactId: string,
  noteId: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(
    getDeleteAdminContactNoteUrl(contactId, noteId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteAdminContactNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminContactNote>>,
    TError,
    { contactId: string; noteId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminContactNote>>,
  TError,
  { contactId: string; noteId: string },
  TContext
> => {
  const mutationKey = ["deleteAdminContactNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminContactNote>>,
    { contactId: string; noteId: string }
  > = (props) => {
    const { contactId, noteId } = props ?? {};

    return deleteAdminContactNote(contactId, noteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminContactNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminContactNote>>
>;

export type DeleteAdminContactNoteMutationError = ErrorType<unknown>;

/**
 * @summary Delete a contact note (author or super_admin only)
 */
export const useDeleteAdminContactNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminContactNote>>,
    TError,
    { contactId: string; noteId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminContactNote>>,
  TError,
  { contactId: string; noteId: string },
  TContext
> => {
  return useMutation(getDeleteAdminContactNoteMutationOptions(options));
};

/**
 * @summary List pending workspace access requests for the admin's org
 */
export const getListAdminAccessRequestsUrl = () => {
  return `/api/admin/access-requests`;
};

export const listAdminAccessRequests = async (
  options?: RequestInit,
): Promise<AdminAccessRequestsResponse> => {
  return customFetch<AdminAccessRequestsResponse>(
    getListAdminAccessRequestsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminAccessRequestsQueryKey = () => {
  return [`/api/admin/access-requests`] as const;
};

export const getListAdminAccessRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAccessRequests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAccessRequests>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminAccessRequestsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminAccessRequests>>
  > = ({ signal }) => listAdminAccessRequests({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminAccessRequests>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminAccessRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAccessRequests>>
>;
export type ListAdminAccessRequestsQueryError = ErrorType<unknown>;

/**
 * @summary List pending workspace access requests for the admin's org
 */

export function useListAdminAccessRequests<
  TData = Awaited<ReturnType<typeof listAdminAccessRequests>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAccessRequests>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminAccessRequestsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Convert an access request into a user + invite email
 */
export const getInviteAdminAccessRequestUrl = (id: string) => {
  return `/api/admin/access-requests/${id}/invite`;
};

export const inviteAdminAccessRequest = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getInviteAdminAccessRequestUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getInviteAdminAccessRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteAdminAccessRequest>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteAdminAccessRequest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["inviteAdminAccessRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteAdminAccessRequest>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return inviteAdminAccessRequest(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteAdminAccessRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteAdminAccessRequest>>
>;

export type InviteAdminAccessRequestMutationError = ErrorType<unknown>;

/**
 * @summary Convert an access request into a user + invite email
 */
export const useInviteAdminAccessRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteAdminAccessRequest>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteAdminAccessRequest>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getInviteAdminAccessRequestMutationOptions(options));
};

/**
 * @summary Dismiss an access request without sending an invite
 */
export const getDismissAdminAccessRequestUrl = (id: string) => {
  return `/api/admin/access-requests/${id}/dismiss`;
};

export const dismissAdminAccessRequest = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDismissAdminAccessRequestUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDismissAdminAccessRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAdminAccessRequest>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissAdminAccessRequest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["dismissAdminAccessRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissAdminAccessRequest>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dismissAdminAccessRequest(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissAdminAccessRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissAdminAccessRequest>>
>;

export type DismissAdminAccessRequestMutationError = ErrorType<unknown>;

/**
 * @summary Dismiss an access request without sending an invite
 */
export const useDismissAdminAccessRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAdminAccessRequest>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissAdminAccessRequest>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDismissAdminAccessRequestMutationOptions(options));
};

/**
 * @summary List recent admin_alerts rows (rate-limited render-failure events)
 */
export const getListAdminAlertsUrl = (params?: ListAdminAlertsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/alerts?${stringifiedParams}`
    : `/api/admin/alerts`;
};

export const listAdminAlerts = async (
  params?: ListAdminAlertsParams,
  options?: RequestInit,
): Promise<AdminAlertsResponse> => {
  return customFetch<AdminAlertsResponse>(getListAdminAlertsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAdminAlertsQueryKey = (params?: ListAdminAlertsParams) => {
  return [`/api/admin/alerts`, ...(params ? [params] : [])] as const;
};

export const getListAdminAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAlerts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminAlertsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlerts>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminAlertsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAlerts>>> = ({
    signal,
  }) => listAdminAlerts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminAlerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAlerts>>
>;
export type ListAdminAlertsQueryError = ErrorType<unknown>;

/**
 * @summary List recent admin_alerts rows (rate-limited render-failure events)
 */

export function useListAdminAlerts<
  TData = Awaited<ReturnType<typeof listAdminAlerts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminAlertsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlerts>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminAlertsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List orgs the current admin can switch into
 */
export const getListAdminOrgsUrl = (params?: ListAdminOrgsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/orgs?${stringifiedParams}`
    : `/api/admin/orgs`;
};

export const listAdminOrgs = async (
  params?: ListAdminOrgsParams,
  options?: RequestInit,
): Promise<ListAdminOrgs200> => {
  return customFetch<ListAdminOrgs200>(getListAdminOrgsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAdminOrgsQueryKey = (params?: ListAdminOrgsParams) => {
  return [`/api/admin/orgs`, ...(params ? [params] : [])] as const;
};

export const getListAdminOrgsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminOrgs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminOrgsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrgs>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminOrgsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminOrgs>>> = ({
    signal,
  }) => listAdminOrgs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminOrgs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminOrgsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminOrgs>>
>;
export type ListAdminOrgsQueryError = ErrorType<unknown>;

/**
 * @summary List orgs the current admin can switch into
 */

export function useListAdminOrgs<
  TData = Awaited<ReturnType<typeof listAdminOrgs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAdminOrgsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrgs>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminOrgsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Run sentiment + topic analysis on demand for an org
 */
export const getRunOrgAnalysisUrl = (id: string) => {
  return `/api/admin/orgs/${id}/run-analysis`;
};

export const runOrgAnalysis = async (
  id: string,
  options?: RequestInit,
): Promise<RunOrgAnalysis200> => {
  return customFetch<RunOrgAnalysis200>(getRunOrgAnalysisUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRunOrgAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runOrgAnalysis>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runOrgAnalysis>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["runOrgAnalysis"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runOrgAnalysis>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return runOrgAnalysis(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunOrgAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof runOrgAnalysis>>
>;

export type RunOrgAnalysisMutationError = ErrorType<unknown>;

/**
 * @summary Run sentiment + topic analysis on demand for an org
 */
export const useRunOrgAnalysis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runOrgAnalysis>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runOrgAnalysis>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRunOrgAnalysisMutationOptions(options));
};

/**
 * @summary Get the admin's currently active org override (if any)
 */
export const getGetActiveOrgPreferenceUrl = () => {
  return `/api/preferences/active-org`;
};

export const getActiveOrgPreference = async (
  options?: RequestInit,
): Promise<GetActiveOrgPreference200> => {
  return customFetch<GetActiveOrgPreference200>(
    getGetActiveOrgPreferenceUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetActiveOrgPreferenceQueryKey = () => {
  return [`/api/preferences/active-org`] as const;
};

export const getGetActiveOrgPreferenceQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveOrgPreference>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveOrgPreference>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveOrgPreferenceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveOrgPreference>>
  > = ({ signal }) => getActiveOrgPreference({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveOrgPreference>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveOrgPreferenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveOrgPreference>>
>;
export type GetActiveOrgPreferenceQueryError = ErrorType<unknown>;

/**
 * @summary Get the admin's currently active org override (if any)
 */

export function useGetActiveOrgPreference<
  TData = Awaited<ReturnType<typeof getActiveOrgPreference>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveOrgPreference>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActiveOrgPreferenceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set or clear the admin's active org override
 */
export const getSetActiveOrgPreferenceUrl = () => {
  return `/api/preferences/active-org`;
};

export const setActiveOrgPreference = async (
  setActiveOrgPreferenceBody: SetActiveOrgPreferenceBody,
  options?: RequestInit,
): Promise<SetActiveOrgPreference200> => {
  return customFetch<SetActiveOrgPreference200>(
    getSetActiveOrgPreferenceUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setActiveOrgPreferenceBody),
    },
  );
};

export const getSetActiveOrgPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setActiveOrgPreference>>,
    TError,
    { data: BodyType<SetActiveOrgPreferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setActiveOrgPreference>>,
  TError,
  { data: BodyType<SetActiveOrgPreferenceBody> },
  TContext
> => {
  const mutationKey = ["setActiveOrgPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setActiveOrgPreference>>,
    { data: BodyType<SetActiveOrgPreferenceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return setActiveOrgPreference(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetActiveOrgPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof setActiveOrgPreference>>
>;
export type SetActiveOrgPreferenceMutationBody =
  BodyType<SetActiveOrgPreferenceBody>;
export type SetActiveOrgPreferenceMutationError = ErrorType<unknown>;

/**
 * @summary Set or clear the admin's active org override
 */
export const useSetActiveOrgPreference = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setActiveOrgPreference>>,
    TError,
    { data: BodyType<SetActiveOrgPreferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setActiveOrgPreference>>,
  TError,
  { data: BodyType<SetActiveOrgPreferenceBody> },
  TContext
> => {
  return useMutation(getSetActiveOrgPreferenceMutationOptions(options));
};

/**
 * @summary Capture a workspace access request from the sign-in screen
 */
export const getCreateAccessRequestUrl = () => {
  return `/api/auth/access-requests`;
};

export const createAccessRequest = async (
  createAccessRequestBody: CreateAccessRequestBody,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getCreateAccessRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAccessRequestBody),
  });
};

export const getCreateAccessRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccessRequest>>,
    TError,
    { data: BodyType<CreateAccessRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccessRequest>>,
  TError,
  { data: BodyType<CreateAccessRequestBody> },
  TContext
> => {
  const mutationKey = ["createAccessRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccessRequest>>,
    { data: BodyType<CreateAccessRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAccessRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccessRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccessRequest>>
>;
export type CreateAccessRequestMutationBody = BodyType<CreateAccessRequestBody>;
export type CreateAccessRequestMutationError = ErrorType<unknown>;

/**
 * @summary Capture a workspace access request from the sign-in screen
 */
export const useCreateAccessRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccessRequest>>,
    TError,
    { data: BodyType<CreateAccessRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAccessRequest>>,
  TError,
  { data: BodyType<CreateAccessRequestBody> },
  TContext
> => {
  return useMutation(getCreateAccessRequestMutationOptions(options));
};

/**
 * @summary List all org subscriptions
 */
export const getListAdminSubscriptionsUrl = () => {
  return `/api/admin/subscriptions`;
};

export const listAdminSubscriptions = async (
  options?: RequestInit,
): Promise<AdminSubscriptionsResponse> => {
  return customFetch<AdminSubscriptionsResponse>(
    getListAdminSubscriptionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminSubscriptionsQueryKey = () => {
  return [`/api/admin/subscriptions`] as const;
};

export const getListAdminSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminSubscriptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminSubscriptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminSubscriptions>>
  > = ({ signal }) => listAdminSubscriptions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminSubscriptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminSubscriptions>>
>;
export type ListAdminSubscriptionsQueryError = ErrorType<unknown>;

/**
 * @summary List all org subscriptions
 */

export function useListAdminSubscriptions<
  TData = Awaited<ReturnType<typeof listAdminSubscriptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptions>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminSubscriptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Change org plan
 */
export const getUpdateAdminSubscriptionUrl = (orgId: string) => {
  return `/api/admin/subscriptions/${orgId}`;
};

export const updateAdminSubscription = async (
  orgId: string,
  updateAdminSubscriptionBody: UpdateAdminSubscriptionBody,
  options?: RequestInit,
): Promise<UpdateAdminSubscription200> => {
  return customFetch<UpdateAdminSubscription200>(
    getUpdateAdminSubscriptionUrl(orgId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateAdminSubscriptionBody),
    },
  );
};

export const getUpdateAdminSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminSubscription>>,
    TError,
    { orgId: string; data: BodyType<UpdateAdminSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminSubscription>>,
  TError,
  { orgId: string; data: BodyType<UpdateAdminSubscriptionBody> },
  TContext
> => {
  const mutationKey = ["updateAdminSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminSubscription>>,
    { orgId: string; data: BodyType<UpdateAdminSubscriptionBody> }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return updateAdminSubscription(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminSubscription>>
>;
export type UpdateAdminSubscriptionMutationBody =
  BodyType<UpdateAdminSubscriptionBody>;
export type UpdateAdminSubscriptionMutationError = ErrorType<unknown>;

/**
 * @summary Change org plan
 */
export const useUpdateAdminSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminSubscription>>,
    TError,
    { orgId: string; data: BodyType<UpdateAdminSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminSubscription>>,
  TError,
  { orgId: string; data: BodyType<UpdateAdminSubscriptionBody> },
  TContext
> => {
  return useMutation(getUpdateAdminSubscriptionMutationOptions(options));
};

/**
 * @summary Get Stripe configuration and products
 */
export const getGetAdminStripeUrl = () => {
  return `/api/admin/stripe`;
};

export const getAdminStripe = async (
  options?: RequestInit,
): Promise<AdminStripeResponse> => {
  return customFetch<AdminStripeResponse>(getGetAdminStripeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminStripeQueryKey = () => {
  return [`/api/admin/stripe`] as const;
};

export const getGetAdminStripeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminStripe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripe>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminStripeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStripe>>> = ({
    signal,
  }) => getAdminStripe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminStripe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminStripeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminStripe>>
>;
export type GetAdminStripeQueryError = ErrorType<unknown>;

/**
 * @summary Get Stripe configuration and products
 */

export function useGetAdminStripe<
  TData = Awaited<ReturnType<typeof getAdminStripe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripe>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminStripeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Re-sync Stripe products
 */
export const getSyncAdminStripeUrl = () => {
  return `/api/admin/stripe/sync`;
};

export const syncAdminStripe = async (
  options?: RequestInit,
): Promise<SyncAdminStripe200> => {
  return customFetch<SyncAdminStripe200>(getSyncAdminStripeUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSyncAdminStripeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncAdminStripe>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncAdminStripe>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["syncAdminStripe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncAdminStripe>>,
    void
  > = () => {
    return syncAdminStripe(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncAdminStripeMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncAdminStripe>>
>;

export type SyncAdminStripeMutationError = ErrorType<unknown>;

/**
 * @summary Re-sync Stripe products
 */
export const useSyncAdminStripe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncAdminStripe>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncAdminStripe>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSyncAdminStripeMutationOptions(options));
};

/**
 * @summary Real usage counters for the active org's current billing period
 */
export const getGetAdminBillingUsageUrl = () => {
  return `/api/admin/billing/usage`;
};

export const getAdminBillingUsage = async (
  options?: RequestInit,
): Promise<AdminBillingUsageResponse> => {
  return customFetch<AdminBillingUsageResponse>(getGetAdminBillingUsageUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminBillingUsageQueryKey = () => {
  return [`/api/admin/billing/usage`] as const;
};

export const getGetAdminBillingUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminBillingUsage>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingUsage>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminBillingUsageQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminBillingUsage>>
  > = ({ signal }) => getAdminBillingUsage({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminBillingUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminBillingUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminBillingUsage>>
>;
export type GetAdminBillingUsageQueryError = ErrorType<unknown>;

/**
 * @summary Real usage counters for the active org's current billing period
 */

export function useGetAdminBillingUsage<
  TData = Awaited<ReturnType<typeof getAdminBillingUsage>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingUsage>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminBillingUsageQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Real Stripe invoices for the active org
 */
export const getListAdminBillingInvoicesUrl = () => {
  return `/api/admin/billing/invoices`;
};

export const listAdminBillingInvoices = async (
  options?: RequestInit,
): Promise<AdminBillingInvoicesResponse> => {
  return customFetch<AdminBillingInvoicesResponse>(
    getListAdminBillingInvoicesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminBillingInvoicesQueryKey = () => {
  return [`/api/admin/billing/invoices`] as const;
};

export const getListAdminBillingInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminBillingInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingInvoices>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminBillingInvoicesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminBillingInvoices>>
  > = ({ signal }) => listAdminBillingInvoices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminBillingInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminBillingInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminBillingInvoices>>
>;
export type ListAdminBillingInvoicesQueryError = ErrorType<unknown>;

/**
 * @summary Real Stripe invoices for the active org
 */

export function useListAdminBillingInvoices<
  TData = Awaited<ReturnType<typeof listAdminBillingInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingInvoices>>,
    TError,
    TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminBillingInvoicesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Search users by email for role management
 */
export const getSearchAdminRoleUsersUrl = (
  params: SearchAdminRoleUsersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/roles/users?${stringifiedParams}`
    : `/api/admin/roles/users`;
};

export const searchAdminRoleUsers = async (
  params: SearchAdminRoleUsersParams,
  options?: RequestInit,
): Promise<AdminRoleUsersResponse> => {
  return customFetch<AdminRoleUsersResponse>(
    getSearchAdminRoleUsersUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchAdminRoleUsersQueryKey = (
  params?: SearchAdminRoleUsersParams,
) => {
  return [`/api/admin/roles/users`, ...(params ? [params] : [])] as const;
};

export const getSearchAdminRoleUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAdminRoleUsers>>,
  TError = ErrorType<unknown>,
>(
  params: SearchAdminRoleUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminRoleUsers>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchAdminRoleUsersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchAdminRoleUsers>>
  > = ({ signal }) =>
    searchAdminRoleUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchAdminRoleUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchAdminRoleUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchAdminRoleUsers>>
>;
export type SearchAdminRoleUsersQueryError = ErrorType<unknown>;

/**
 * @summary Search users by email for role management
 */

export function useSearchAdminRoleUsers<
  TData = Awaited<ReturnType<typeof searchAdminRoleUsers>>,
  TError = ErrorType<unknown>,
>(
  params: SearchAdminRoleUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminRoleUsers>>,
      TError,
      TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchAdminRoleUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Change a user's role
 */
export const getUpdateAdminRoleUrl = (userId: string) => {
  return `/api/admin/roles/${userId}`;
};

export const updateAdminRole = async (
  userId: string,
  updateAdminRoleBody: UpdateAdminRoleBody,
  options?: RequestInit,
): Promise<UpdateAdminRole200> => {
  return customFetch<UpdateAdminRole200>(getUpdateAdminRoleUrl(userId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAdminRoleBody),
  });
};

export const getUpdateAdminRoleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminRole>>,
    TError,
    { userId: string; data: BodyType<UpdateAdminRoleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminRole>>,
  TError,
  { userId: string; data: BodyType<UpdateAdminRoleBody> },
  TContext
> => {
  const mutationKey = ["updateAdminRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminRole>>,
    { userId: string; data: BodyType<UpdateAdminRoleBody> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateAdminRole(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminRole>>
>;
export type UpdateAdminRoleMutationBody = BodyType<UpdateAdminRoleBody>;
export type UpdateAdminRoleMutationError = ErrorType<unknown>;

/**
 * @summary Change a user's role
 */
export const useUpdateAdminRole = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminRole>>,
    TError,
    { userId: string; data: BodyType<UpdateAdminRoleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminRole>>,
  TError,
  { userId: string; data: BodyType<UpdateAdminRoleBody> },
  TContext
> => {
  return useMutation(getUpdateAdminRoleMutationOptions(options));
};
